function Re(n) {
  const e = { ...n };
  return e.language = n.language === "jp" ? "ja" : n.language, e;
}
function u(n) {
  for (var e = arguments.length, a = new Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++)
    a[r - 1] = arguments[r];
  const s = n.length - 1;
  return n.slice(0, s).reduce((i, o, l) => i + o + a[l], "") + n[s];
}
var k;
(function(n) {
  n.assertEqual = (s) => s;
  function e(s) {
  }
  n.assertIs = e;
  function a(s) {
    throw new Error();
  }
  n.assertNever = a, n.arrayToEnum = (s) => {
    const i = {};
    for (const o of s)
      i[o] = o;
    return i;
  }, n.getValidEnumValues = (s) => {
    const i = n.objectKeys(s).filter((l) => typeof s[s[l]] != "number"), o = {};
    for (const l of i)
      o[l] = s[l];
    return n.objectValues(o);
  }, n.objectValues = (s) => n.objectKeys(s).map(function(i) {
    return s[i];
  }), n.objectKeys = typeof Object.keys == "function" ? (s) => Object.keys(s) : (s) => {
    const i = [];
    for (const o in s)
      Object.prototype.hasOwnProperty.call(s, o) && i.push(o);
    return i;
  }, n.find = (s, i) => {
    for (const o of s)
      if (i(o))
        return o;
  }, n.isInteger = typeof Number.isInteger == "function" ? (s) => Number.isInteger(s) : (s) => typeof s == "number" && isFinite(s) && Math.floor(s) === s;
  function r(s, i = " | ") {
    return s.map((o) => typeof o == "string" ? `'${o}'` : o).join(i);
  }
  n.joinValues = r, n.jsonStringifyReplacer = (s, i) => typeof i == "bigint" ? i.toString() : i;
})(k || (k = {}));
var Ie;
(function(n) {
  n.mergeShapes = (e, a) => ({
    ...e,
    ...a
    // second overwrites first
  });
})(Ie || (Ie = {}));
const d = k.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), B = (n) => {
  switch (typeof n) {
    case "undefined":
      return d.undefined;
    case "string":
      return d.string;
    case "number":
      return isNaN(n) ? d.nan : d.number;
    case "boolean":
      return d.boolean;
    case "function":
      return d.function;
    case "bigint":
      return d.bigint;
    case "symbol":
      return d.symbol;
    case "object":
      return Array.isArray(n) ? d.array : n === null ? d.null : n.then && typeof n.then == "function" && n.catch && typeof n.catch == "function" ? d.promise : typeof Map < "u" && n instanceof Map ? d.map : typeof Set < "u" && n instanceof Set ? d.set : typeof Date < "u" && n instanceof Date ? d.date : d.object;
    default:
      return d.unknown;
  }
}, c = k.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), It = (n) => JSON.stringify(n, null, 2).replace(/"([^"]+)":/g, "$1:");
class E extends Error {
  constructor(e) {
    super(), this.issues = [], this.addIssue = (r) => {
      this.issues = [...this.issues, r];
    }, this.addIssues = (r = []) => {
      this.issues = [...this.issues, ...r];
    };
    const a = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, a) : this.__proto__ = a, this.name = "ZodError", this.issues = e;
  }
  get errors() {
    return this.issues;
  }
  format(e) {
    const a = e || function(i) {
      return i.message;
    }, r = { _errors: [] }, s = (i) => {
      for (const o of i.issues)
        if (o.code === "invalid_union")
          o.unionErrors.map(s);
        else if (o.code === "invalid_return_type")
          s(o.returnTypeError);
        else if (o.code === "invalid_arguments")
          s(o.argumentsError);
        else if (o.path.length === 0)
          r._errors.push(a(o));
        else {
          let l = r, h = 0;
          for (; h < o.path.length; ) {
            const m = o.path[h];
            h === o.path.length - 1 ? (l[m] = l[m] || { _errors: [] }, l[m]._errors.push(a(o))) : l[m] = l[m] || { _errors: [] }, l = l[m], h++;
          }
        }
    };
    return s(this), r;
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, k.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (a) => a.message) {
    const a = {}, r = [];
    for (const s of this.issues)
      s.path.length > 0 ? (a[s.path[0]] = a[s.path[0]] || [], a[s.path[0]].push(e(s))) : r.push(e(s));
    return { formErrors: r, fieldErrors: a };
  }
  get formErrors() {
    return this.flatten();
  }
}
E.create = (n) => new E(n);
const te = (n, e) => {
  let a;
  switch (n.code) {
    case c.invalid_type:
      n.received === d.undefined ? a = "Required" : a = `Expected ${n.expected}, received ${n.received}`;
      break;
    case c.invalid_literal:
      a = `Invalid literal value, expected ${JSON.stringify(n.expected, k.jsonStringifyReplacer)}`;
      break;
    case c.unrecognized_keys:
      a = `Unrecognized key(s) in object: ${k.joinValues(n.keys, ", ")}`;
      break;
    case c.invalid_union:
      a = "Invalid input";
      break;
    case c.invalid_union_discriminator:
      a = `Invalid discriminator value. Expected ${k.joinValues(n.options)}`;
      break;
    case c.invalid_enum_value:
      a = `Invalid enum value. Expected ${k.joinValues(n.options)}, received '${n.received}'`;
      break;
    case c.invalid_arguments:
      a = "Invalid function arguments";
      break;
    case c.invalid_return_type:
      a = "Invalid function return type";
      break;
    case c.invalid_date:
      a = "Invalid date";
      break;
    case c.invalid_string:
      typeof n.validation == "object" ? "includes" in n.validation ? (a = `Invalid input: must include "${n.validation.includes}"`, typeof n.validation.position == "number" && (a = `${a} at one or more positions greater than or equal to ${n.validation.position}`)) : "startsWith" in n.validation ? a = `Invalid input: must start with "${n.validation.startsWith}"` : "endsWith" in n.validation ? a = `Invalid input: must end with "${n.validation.endsWith}"` : k.assertNever(n.validation) : n.validation !== "regex" ? a = `Invalid ${n.validation}` : a = "Invalid";
      break;
    case c.too_small:
      n.type === "array" ? a = `Array must contain ${n.exact ? "exactly" : n.inclusive ? "at least" : "more than"} ${n.minimum} element(s)` : n.type === "string" ? a = `String must contain ${n.exact ? "exactly" : n.inclusive ? "at least" : "over"} ${n.minimum} character(s)` : n.type === "number" ? a = `Number must be ${n.exact ? "exactly equal to " : n.inclusive ? "greater than or equal to " : "greater than "}${n.minimum}` : n.type === "date" ? a = `Date must be ${n.exact ? "exactly equal to " : n.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(n.minimum))}` : a = "Invalid input";
      break;
    case c.too_big:
      n.type === "array" ? a = `Array must contain ${n.exact ? "exactly" : n.inclusive ? "at most" : "less than"} ${n.maximum} element(s)` : n.type === "string" ? a = `String must contain ${n.exact ? "exactly" : n.inclusive ? "at most" : "under"} ${n.maximum} character(s)` : n.type === "number" ? a = `Number must be ${n.exact ? "exactly" : n.inclusive ? "less than or equal to" : "less than"} ${n.maximum}` : n.type === "bigint" ? a = `BigInt must be ${n.exact ? "exactly" : n.inclusive ? "less than or equal to" : "less than"} ${n.maximum}` : n.type === "date" ? a = `Date must be ${n.exact ? "exactly" : n.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(n.maximum))}` : a = "Invalid input";
      break;
    case c.custom:
      a = "Invalid input";
      break;
    case c.invalid_intersection_types:
      a = "Intersection results could not be merged";
      break;
    case c.not_multiple_of:
      a = `Number must be a multiple of ${n.multipleOf}`;
      break;
    case c.not_finite:
      a = "Number must be finite";
      break;
    default:
      a = e.defaultError, k.assertNever(n);
  }
  return { message: a };
};
let We = te;
function Zt(n) {
  We = n;
}
function ge() {
  return We;
}
const fe = (n) => {
  const { data: e, path: a, errorMaps: r, issueData: s } = n, i = [...a, ...s.path || []], o = {
    ...s,
    path: i
  };
  let l = "";
  const h = r.filter((m) => !!m).slice().reverse();
  for (const m of h)
    l = m(o, { data: e, defaultError: l }).message;
  return {
    ...s,
    path: i,
    message: s.message || l
  };
}, Et = [];
function p(n, e) {
  const a = fe({
    issueData: e,
    data: n.data,
    path: n.path,
    errorMaps: [
      n.common.contextualErrorMap,
      n.schemaErrorMap,
      ge(),
      te
      // then global default map
    ].filter((r) => !!r)
  });
  n.common.issues.push(a);
}
class C {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, a) {
    const r = [];
    for (const s of a) {
      if (s.status === "aborted")
        return y;
      s.status === "dirty" && e.dirty(), r.push(s.value);
    }
    return { status: e.value, value: r };
  }
  static async mergeObjectAsync(e, a) {
    const r = [];
    for (const s of a)
      r.push({
        key: await s.key,
        value: await s.value
      });
    return C.mergeObjectSync(e, r);
  }
  static mergeObjectSync(e, a) {
    const r = {};
    for (const s of a) {
      const { key: i, value: o } = s;
      if (i.status === "aborted" || o.status === "aborted")
        return y;
      i.status === "dirty" && e.dirty(), o.status === "dirty" && e.dirty(), (typeof o.value < "u" || s.alwaysSet) && (r[i.value] = o.value);
    }
    return { status: e.value, value: r };
  }
}
const y = Object.freeze({
  status: "aborted"
}), Fe = (n) => ({ status: "dirty", value: n }), I = (n) => ({ status: "valid", value: n }), Ze = (n) => n.status === "aborted", Ee = (n) => n.status === "dirty", ye = (n) => n.status === "valid", ve = (n) => typeof Promise < "u" && n instanceof Promise;
var g;
(function(n) {
  n.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, n.toString = (e) => typeof e == "string" ? e : e == null ? void 0 : e.message;
})(g || (g = {}));
class R {
  constructor(e, a, r, s) {
    this._cachedPath = [], this.parent = e, this.data = a, this._path = r, this._key = s;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const Ue = (n, e) => {
  if (ye(e))
    return { success: !0, data: e.value };
  if (!n.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const a = new E(n.common.issues);
      return this._error = a, this._error;
    }
  };
};
function v(n) {
  if (!n)
    return {};
  const { errorMap: e, invalid_type_error: a, required_error: r, description: s } = n;
  if (e && (a || r))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: s } : { errorMap: (o, l) => o.code !== "invalid_type" ? { message: l.defaultError } : typeof l.data > "u" ? { message: r ?? l.defaultError } : { message: a ?? l.defaultError }, description: s };
}
class _ {
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this);
  }
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return B(e.data);
  }
  _getOrReturnCtx(e, a) {
    return a || {
      common: e.parent.common,
      data: e.data,
      parsedType: B(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new C(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: B(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const a = this._parse(e);
    if (ve(a))
      throw new Error("Synchronous parse encountered promise.");
    return a;
  }
  _parseAsync(e) {
    const a = this._parse(e);
    return Promise.resolve(a);
  }
  parse(e, a) {
    const r = this.safeParse(e, a);
    if (r.success)
      return r.data;
    throw r.error;
  }
  safeParse(e, a) {
    var r;
    const s = {
      common: {
        issues: [],
        async: (r = a == null ? void 0 : a.async) !== null && r !== void 0 ? r : !1,
        contextualErrorMap: a == null ? void 0 : a.errorMap
      },
      path: (a == null ? void 0 : a.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: B(e)
    }, i = this._parseSync({ data: e, path: s.path, parent: s });
    return Ue(s, i);
  }
  async parseAsync(e, a) {
    const r = await this.safeParseAsync(e, a);
    if (r.success)
      return r.data;
    throw r.error;
  }
  async safeParseAsync(e, a) {
    const r = {
      common: {
        issues: [],
        contextualErrorMap: a == null ? void 0 : a.errorMap,
        async: !0
      },
      path: (a == null ? void 0 : a.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: B(e)
    }, s = this._parse({ data: e, path: r.path, parent: r }), i = await (ve(s) ? s : Promise.resolve(s));
    return Ue(r, i);
  }
  refine(e, a) {
    const r = (s) => typeof a == "string" || typeof a > "u" ? { message: a } : typeof a == "function" ? a(s) : a;
    return this._refinement((s, i) => {
      const o = e(s), l = () => i.addIssue({
        code: c.custom,
        ...r(s)
      });
      return typeof Promise < "u" && o instanceof Promise ? o.then((h) => h ? !0 : (l(), !1)) : o ? !0 : (l(), !1);
    });
  }
  refinement(e, a) {
    return this._refinement((r, s) => e(r) ? !0 : (s.addIssue(typeof a == "function" ? a(r, s) : a), !1));
  }
  _refinement(e) {
    return new A({
      schema: this,
      typeName: f.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  optional() {
    return M.create(this, this._def);
  }
  nullable() {
    return F.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return O.create(this, this._def);
  }
  promise() {
    return X.create(this, this._def);
  }
  or(e) {
    return se.create([this, e], this._def);
  }
  and(e) {
    return ie.create(this, e, this._def);
  }
  transform(e) {
    return new A({
      ...v(this._def),
      schema: this,
      typeName: f.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const a = typeof e == "function" ? e : () => e;
    return new de({
      ...v(this._def),
      innerType: this,
      defaultValue: a,
      typeName: f.ZodDefault
    });
  }
  brand() {
    return new He({
      typeName: f.ZodBranded,
      type: this,
      ...v(this._def)
    });
  }
  catch(e) {
    const a = typeof e == "function" ? e : () => e;
    return new ke({
      ...v(this._def),
      innerType: this,
      catchValue: a,
      typeName: f.ZodCatch
    });
  }
  describe(e) {
    const a = this.constructor;
    return new a({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return pe.create(this, e);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const Ot = /^c[^\s-]{8,}$/i, At = /^[a-z][a-z0-9]*$/, Nt = /[0-9A-HJKMNP-TV-Z]{26}/, Rt = /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i, Lt = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/, Mt = new RegExp("^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$", "u"), Pt = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/, Bt = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/, Qt = (n) => n.precision ? n.offset ? new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${n.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`) : new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${n.precision}}Z$`) : n.precision === 0 ? n.offset ? new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$") : new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$") : n.offset ? new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$") : new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$");
function Dt(n, e) {
  return !!((e === "v4" || !e) && Pt.test(n) || (e === "v6" || !e) && Bt.test(n));
}
class Z extends _ {
  constructor() {
    super(...arguments), this._regex = (e, a, r) => this.refinement((s) => e.test(s), {
      validation: a,
      code: c.invalid_string,
      ...g.errToObj(r)
    }), this.nonempty = (e) => this.min(1, g.errToObj(e)), this.trim = () => new Z({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    }), this.toLowerCase = () => new Z({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    }), this.toUpperCase = () => new Z({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== d.string) {
      const i = this._getOrReturnCtx(e);
      return p(
        i,
        {
          code: c.invalid_type,
          expected: d.string,
          received: i.parsedType
        }
        //
      ), y;
    }
    const r = new C();
    let s;
    for (const i of this._def.checks)
      if (i.kind === "min")
        e.data.length < i.value && (s = this._getOrReturnCtx(e, s), p(s, {
          code: c.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), r.dirty());
      else if (i.kind === "max")
        e.data.length > i.value && (s = this._getOrReturnCtx(e, s), p(s, {
          code: c.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), r.dirty());
      else if (i.kind === "length") {
        const o = e.data.length > i.value, l = e.data.length < i.value;
        (o || l) && (s = this._getOrReturnCtx(e, s), o ? p(s, {
          code: c.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }) : l && p(s, {
          code: c.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }), r.dirty());
      } else if (i.kind === "email")
        Lt.test(e.data) || (s = this._getOrReturnCtx(e, s), p(s, {
          validation: "email",
          code: c.invalid_string,
          message: i.message
        }), r.dirty());
      else if (i.kind === "emoji")
        Mt.test(e.data) || (s = this._getOrReturnCtx(e, s), p(s, {
          validation: "emoji",
          code: c.invalid_string,
          message: i.message
        }), r.dirty());
      else if (i.kind === "uuid")
        Rt.test(e.data) || (s = this._getOrReturnCtx(e, s), p(s, {
          validation: "uuid",
          code: c.invalid_string,
          message: i.message
        }), r.dirty());
      else if (i.kind === "cuid")
        Ot.test(e.data) || (s = this._getOrReturnCtx(e, s), p(s, {
          validation: "cuid",
          code: c.invalid_string,
          message: i.message
        }), r.dirty());
      else if (i.kind === "cuid2")
        At.test(e.data) || (s = this._getOrReturnCtx(e, s), p(s, {
          validation: "cuid2",
          code: c.invalid_string,
          message: i.message
        }), r.dirty());
      else if (i.kind === "ulid")
        Nt.test(e.data) || (s = this._getOrReturnCtx(e, s), p(s, {
          validation: "ulid",
          code: c.invalid_string,
          message: i.message
        }), r.dirty());
      else if (i.kind === "url")
        try {
          new URL(e.data);
        } catch {
          s = this._getOrReturnCtx(e, s), p(s, {
            validation: "url",
            code: c.invalid_string,
            message: i.message
          }), r.dirty();
        }
      else i.kind === "regex" ? (i.regex.lastIndex = 0, i.regex.test(e.data) || (s = this._getOrReturnCtx(e, s), p(s, {
        validation: "regex",
        code: c.invalid_string,
        message: i.message
      }), r.dirty())) : i.kind === "trim" ? e.data = e.data.trim() : i.kind === "includes" ? e.data.includes(i.value, i.position) || (s = this._getOrReturnCtx(e, s), p(s, {
        code: c.invalid_string,
        validation: { includes: i.value, position: i.position },
        message: i.message
      }), r.dirty()) : i.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : i.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : i.kind === "startsWith" ? e.data.startsWith(i.value) || (s = this._getOrReturnCtx(e, s), p(s, {
        code: c.invalid_string,
        validation: { startsWith: i.value },
        message: i.message
      }), r.dirty()) : i.kind === "endsWith" ? e.data.endsWith(i.value) || (s = this._getOrReturnCtx(e, s), p(s, {
        code: c.invalid_string,
        validation: { endsWith: i.value },
        message: i.message
      }), r.dirty()) : i.kind === "datetime" ? Qt(i).test(e.data) || (s = this._getOrReturnCtx(e, s), p(s, {
        code: c.invalid_string,
        validation: "datetime",
        message: i.message
      }), r.dirty()) : i.kind === "ip" ? Dt(e.data, i.version) || (s = this._getOrReturnCtx(e, s), p(s, {
        validation: "ip",
        code: c.invalid_string,
        message: i.message
      }), r.dirty()) : k.assertNever(i);
    return { status: r.value, value: e.data };
  }
  _addCheck(e) {
    return new Z({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...g.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...g.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...g.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...g.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...g.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...g.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...g.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...g.errToObj(e) });
  }
  datetime(e) {
    var a;
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      offset: (a = e == null ? void 0 : e.offset) !== null && a !== void 0 ? a : !1,
      ...g.errToObj(e == null ? void 0 : e.message)
    });
  }
  regex(e, a) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...g.errToObj(a)
    });
  }
  includes(e, a) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: a == null ? void 0 : a.position,
      ...g.errToObj(a == null ? void 0 : a.message)
    });
  }
  startsWith(e, a) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...g.errToObj(a)
    });
  }
  endsWith(e, a) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...g.errToObj(a)
    });
  }
  min(e, a) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...g.errToObj(a)
    });
  }
  max(e, a) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...g.errToObj(a)
    });
  }
  length(e, a) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...g.errToObj(a)
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get minLength() {
    let e = null;
    for (const a of this._def.checks)
      a.kind === "min" && (e === null || a.value > e) && (e = a.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const a of this._def.checks)
      a.kind === "max" && (e === null || a.value < e) && (e = a.value);
    return e;
  }
}
Z.create = (n) => {
  var e;
  return new Z({
    checks: [],
    typeName: f.ZodString,
    coerce: (e = n == null ? void 0 : n.coerce) !== null && e !== void 0 ? e : !1,
    ...v(n)
  });
};
function Vt(n, e) {
  const a = (n.toString().split(".")[1] || "").length, r = (e.toString().split(".")[1] || "").length, s = a > r ? a : r, i = parseInt(n.toFixed(s).replace(".", "")), o = parseInt(e.toFixed(s).replace(".", ""));
  return i % o / Math.pow(10, s);
}
class Q extends _ {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== d.number) {
      const i = this._getOrReturnCtx(e);
      return p(i, {
        code: c.invalid_type,
        expected: d.number,
        received: i.parsedType
      }), y;
    }
    let r;
    const s = new C();
    for (const i of this._def.checks)
      i.kind === "int" ? k.isInteger(e.data) || (r = this._getOrReturnCtx(e, r), p(r, {
        code: c.invalid_type,
        expected: "integer",
        received: "float",
        message: i.message
      }), s.dirty()) : i.kind === "min" ? (i.inclusive ? e.data < i.value : e.data <= i.value) && (r = this._getOrReturnCtx(e, r), p(r, {
        code: c.too_small,
        minimum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), s.dirty()) : i.kind === "max" ? (i.inclusive ? e.data > i.value : e.data >= i.value) && (r = this._getOrReturnCtx(e, r), p(r, {
        code: c.too_big,
        maximum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), s.dirty()) : i.kind === "multipleOf" ? Vt(e.data, i.value) !== 0 && (r = this._getOrReturnCtx(e, r), p(r, {
        code: c.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), s.dirty()) : i.kind === "finite" ? Number.isFinite(e.data) || (r = this._getOrReturnCtx(e, r), p(r, {
        code: c.not_finite,
        message: i.message
      }), s.dirty()) : k.assertNever(i);
    return { status: s.value, value: e.data };
  }
  gte(e, a) {
    return this.setLimit("min", e, !0, g.toString(a));
  }
  gt(e, a) {
    return this.setLimit("min", e, !1, g.toString(a));
  }
  lte(e, a) {
    return this.setLimit("max", e, !0, g.toString(a));
  }
  lt(e, a) {
    return this.setLimit("max", e, !1, g.toString(a));
  }
  setLimit(e, a, r, s) {
    return new Q({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: a,
          inclusive: r,
          message: g.toString(s)
        }
      ]
    });
  }
  _addCheck(e) {
    return new Q({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: g.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: g.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: g.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: g.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: g.toString(e)
    });
  }
  multipleOf(e, a) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: g.toString(a)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: g.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: g.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: g.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const a of this._def.checks)
      a.kind === "min" && (e === null || a.value > e) && (e = a.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const a of this._def.checks)
      a.kind === "max" && (e === null || a.value < e) && (e = a.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && k.isInteger(e.value));
  }
  get isFinite() {
    let e = null, a = null;
    for (const r of this._def.checks) {
      if (r.kind === "finite" || r.kind === "int" || r.kind === "multipleOf")
        return !0;
      r.kind === "min" ? (a === null || r.value > a) && (a = r.value) : r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    }
    return Number.isFinite(a) && Number.isFinite(e);
  }
}
Q.create = (n) => new Q({
  checks: [],
  typeName: f.ZodNumber,
  coerce: (n == null ? void 0 : n.coerce) || !1,
  ...v(n)
});
class D extends _ {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = BigInt(e.data)), this._getType(e) !== d.bigint) {
      const i = this._getOrReturnCtx(e);
      return p(i, {
        code: c.invalid_type,
        expected: d.bigint,
        received: i.parsedType
      }), y;
    }
    let r;
    const s = new C();
    for (const i of this._def.checks)
      i.kind === "min" ? (i.inclusive ? e.data < i.value : e.data <= i.value) && (r = this._getOrReturnCtx(e, r), p(r, {
        code: c.too_small,
        type: "bigint",
        minimum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), s.dirty()) : i.kind === "max" ? (i.inclusive ? e.data > i.value : e.data >= i.value) && (r = this._getOrReturnCtx(e, r), p(r, {
        code: c.too_big,
        type: "bigint",
        maximum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), s.dirty()) : i.kind === "multipleOf" ? e.data % i.value !== BigInt(0) && (r = this._getOrReturnCtx(e, r), p(r, {
        code: c.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), s.dirty()) : k.assertNever(i);
    return { status: s.value, value: e.data };
  }
  gte(e, a) {
    return this.setLimit("min", e, !0, g.toString(a));
  }
  gt(e, a) {
    return this.setLimit("min", e, !1, g.toString(a));
  }
  lte(e, a) {
    return this.setLimit("max", e, !0, g.toString(a));
  }
  lt(e, a) {
    return this.setLimit("max", e, !1, g.toString(a));
  }
  setLimit(e, a, r, s) {
    return new D({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: a,
          inclusive: r,
          message: g.toString(s)
        }
      ]
    });
  }
  _addCheck(e) {
    return new D({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: g.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: g.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: g.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: g.toString(e)
    });
  }
  multipleOf(e, a) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: g.toString(a)
    });
  }
  get minValue() {
    let e = null;
    for (const a of this._def.checks)
      a.kind === "min" && (e === null || a.value > e) && (e = a.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const a of this._def.checks)
      a.kind === "max" && (e === null || a.value < e) && (e = a.value);
    return e;
  }
}
D.create = (n) => {
  var e;
  return new D({
    checks: [],
    typeName: f.ZodBigInt,
    coerce: (e = n == null ? void 0 : n.coerce) !== null && e !== void 0 ? e : !1,
    ...v(n)
  });
};
class ae extends _ {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== d.boolean) {
      const r = this._getOrReturnCtx(e);
      return p(r, {
        code: c.invalid_type,
        expected: d.boolean,
        received: r.parsedType
      }), y;
    }
    return I(e.data);
  }
}
ae.create = (n) => new ae({
  typeName: f.ZodBoolean,
  coerce: (n == null ? void 0 : n.coerce) || !1,
  ...v(n)
});
class q extends _ {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== d.date) {
      const i = this._getOrReturnCtx(e);
      return p(i, {
        code: c.invalid_type,
        expected: d.date,
        received: i.parsedType
      }), y;
    }
    if (isNaN(e.data.getTime())) {
      const i = this._getOrReturnCtx(e);
      return p(i, {
        code: c.invalid_date
      }), y;
    }
    const r = new C();
    let s;
    for (const i of this._def.checks)
      i.kind === "min" ? e.data.getTime() < i.value && (s = this._getOrReturnCtx(e, s), p(s, {
        code: c.too_small,
        message: i.message,
        inclusive: !0,
        exact: !1,
        minimum: i.value,
        type: "date"
      }), r.dirty()) : i.kind === "max" ? e.data.getTime() > i.value && (s = this._getOrReturnCtx(e, s), p(s, {
        code: c.too_big,
        message: i.message,
        inclusive: !0,
        exact: !1,
        maximum: i.value,
        type: "date"
      }), r.dirty()) : k.assertNever(i);
    return {
      status: r.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new q({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, a) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: g.toString(a)
    });
  }
  max(e, a) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: g.toString(a)
    });
  }
  get minDate() {
    let e = null;
    for (const a of this._def.checks)
      a.kind === "min" && (e === null || a.value > e) && (e = a.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const a of this._def.checks)
      a.kind === "max" && (e === null || a.value < e) && (e = a.value);
    return e != null ? new Date(e) : null;
  }
}
q.create = (n) => new q({
  checks: [],
  coerce: (n == null ? void 0 : n.coerce) || !1,
  typeName: f.ZodDate,
  ...v(n)
});
class _e extends _ {
  _parse(e) {
    if (this._getType(e) !== d.symbol) {
      const r = this._getOrReturnCtx(e);
      return p(r, {
        code: c.invalid_type,
        expected: d.symbol,
        received: r.parsedType
      }), y;
    }
    return I(e.data);
  }
}
_e.create = (n) => new _e({
  typeName: f.ZodSymbol,
  ...v(n)
});
class ne extends _ {
  _parse(e) {
    if (this._getType(e) !== d.undefined) {
      const r = this._getOrReturnCtx(e);
      return p(r, {
        code: c.invalid_type,
        expected: d.undefined,
        received: r.parsedType
      }), y;
    }
    return I(e.data);
  }
}
ne.create = (n) => new ne({
  typeName: f.ZodUndefined,
  ...v(n)
});
class re extends _ {
  _parse(e) {
    if (this._getType(e) !== d.null) {
      const r = this._getOrReturnCtx(e);
      return p(r, {
        code: c.invalid_type,
        expected: d.null,
        received: r.parsedType
      }), y;
    }
    return I(e.data);
  }
}
re.create = (n) => new re({
  typeName: f.ZodNull,
  ...v(n)
});
class Y extends _ {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return I(e.data);
  }
}
Y.create = (n) => new Y({
  typeName: f.ZodAny,
  ...v(n)
});
class z extends _ {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return I(e.data);
  }
}
z.create = (n) => new z({
  typeName: f.ZodUnknown,
  ...v(n)
});
class P extends _ {
  _parse(e) {
    const a = this._getOrReturnCtx(e);
    return p(a, {
      code: c.invalid_type,
      expected: d.never,
      received: a.parsedType
    }), y;
  }
}
P.create = (n) => new P({
  typeName: f.ZodNever,
  ...v(n)
});
class be extends _ {
  _parse(e) {
    if (this._getType(e) !== d.undefined) {
      const r = this._getOrReturnCtx(e);
      return p(r, {
        code: c.invalid_type,
        expected: d.void,
        received: r.parsedType
      }), y;
    }
    return I(e.data);
  }
}
be.create = (n) => new be({
  typeName: f.ZodVoid,
  ...v(n)
});
class O extends _ {
  _parse(e) {
    const { ctx: a, status: r } = this._processInputParams(e), s = this._def;
    if (a.parsedType !== d.array)
      return p(a, {
        code: c.invalid_type,
        expected: d.array,
        received: a.parsedType
      }), y;
    if (s.exactLength !== null) {
      const o = a.data.length > s.exactLength.value, l = a.data.length < s.exactLength.value;
      (o || l) && (p(a, {
        code: o ? c.too_big : c.too_small,
        minimum: l ? s.exactLength.value : void 0,
        maximum: o ? s.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: s.exactLength.message
      }), r.dirty());
    }
    if (s.minLength !== null && a.data.length < s.minLength.value && (p(a, {
      code: c.too_small,
      minimum: s.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: s.minLength.message
    }), r.dirty()), s.maxLength !== null && a.data.length > s.maxLength.value && (p(a, {
      code: c.too_big,
      maximum: s.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: s.maxLength.message
    }), r.dirty()), a.common.async)
      return Promise.all([...a.data].map((o, l) => s.type._parseAsync(new R(a, o, a.path, l)))).then((o) => C.mergeArray(r, o));
    const i = [...a.data].map((o, l) => s.type._parseSync(new R(a, o, a.path, l)));
    return C.mergeArray(r, i);
  }
  get element() {
    return this._def.type;
  }
  min(e, a) {
    return new O({
      ...this._def,
      minLength: { value: e, message: g.toString(a) }
    });
  }
  max(e, a) {
    return new O({
      ...this._def,
      maxLength: { value: e, message: g.toString(a) }
    });
  }
  length(e, a) {
    return new O({
      ...this._def,
      exactLength: { value: e, message: g.toString(a) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
O.create = (n, e) => new O({
  type: n,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: f.ZodArray,
  ...v(e)
});
function H(n) {
  if (n instanceof w) {
    const e = {};
    for (const a in n.shape) {
      const r = n.shape[a];
      e[a] = M.create(H(r));
    }
    return new w({
      ...n._def,
      shape: () => e
    });
  } else return n instanceof O ? new O({
    ...n._def,
    type: H(n.element)
  }) : n instanceof M ? M.create(H(n.unwrap())) : n instanceof F ? F.create(H(n.unwrap())) : n instanceof L ? L.create(n.items.map((e) => H(e))) : n;
}
class w extends _ {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), a = k.objectKeys(e);
    return this._cached = { shape: e, keys: a };
  }
  _parse(e) {
    if (this._getType(e) !== d.object) {
      const m = this._getOrReturnCtx(e);
      return p(m, {
        code: c.invalid_type,
        expected: d.object,
        received: m.parsedType
      }), y;
    }
    const { status: r, ctx: s } = this._processInputParams(e), { shape: i, keys: o } = this._getCached(), l = [];
    if (!(this._def.catchall instanceof P && this._def.unknownKeys === "strip"))
      for (const m in s.data)
        o.includes(m) || l.push(m);
    const h = [];
    for (const m of o) {
      const b = i[m], G = s.data[m];
      h.push({
        key: { status: "valid", value: m },
        value: b._parse(new R(s, G, s.path, m)),
        alwaysSet: m in s.data
      });
    }
    if (this._def.catchall instanceof P) {
      const m = this._def.unknownKeys;
      if (m === "passthrough")
        for (const b of l)
          h.push({
            key: { status: "valid", value: b },
            value: { status: "valid", value: s.data[b] }
          });
      else if (m === "strict")
        l.length > 0 && (p(s, {
          code: c.unrecognized_keys,
          keys: l
        }), r.dirty());
      else if (m !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const m = this._def.catchall;
      for (const b of l) {
        const G = s.data[b];
        h.push({
          key: { status: "valid", value: b },
          value: m._parse(
            new R(s, G, s.path, b)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: b in s.data
        });
      }
    }
    return s.common.async ? Promise.resolve().then(async () => {
      const m = [];
      for (const b of h) {
        const G = await b.key;
        m.push({
          key: G,
          value: await b.value,
          alwaysSet: b.alwaysSet
        });
      }
      return m;
    }).then((m) => C.mergeObjectSync(r, m)) : C.mergeObjectSync(r, h);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return g.errToObj, new w({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (a, r) => {
          var s, i, o, l;
          const h = (o = (i = (s = this._def).errorMap) === null || i === void 0 ? void 0 : i.call(s, a, r).message) !== null && o !== void 0 ? o : r.defaultError;
          return a.code === "unrecognized_keys" ? {
            message: (l = g.errToObj(e).message) !== null && l !== void 0 ? l : h
          } : {
            message: h
          };
        }
      } : {}
    });
  }
  strip() {
    return new w({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new w({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new w({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new w({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: f.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, a) {
    return this.augment({ [e]: a });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new w({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const a = {};
    return k.objectKeys(e).forEach((r) => {
      e[r] && this.shape[r] && (a[r] = this.shape[r]);
    }), new w({
      ...this._def,
      shape: () => a
    });
  }
  omit(e) {
    const a = {};
    return k.objectKeys(this.shape).forEach((r) => {
      e[r] || (a[r] = this.shape[r]);
    }), new w({
      ...this._def,
      shape: () => a
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return H(this);
  }
  partial(e) {
    const a = {};
    return k.objectKeys(this.shape).forEach((r) => {
      const s = this.shape[r];
      e && !e[r] ? a[r] = s : a[r] = s.optional();
    }), new w({
      ...this._def,
      shape: () => a
    });
  }
  required(e) {
    const a = {};
    return k.objectKeys(this.shape).forEach((r) => {
      if (e && !e[r])
        a[r] = this.shape[r];
      else {
        let i = this.shape[r];
        for (; i instanceof M; )
          i = i._def.innerType;
        a[r] = i;
      }
    }), new w({
      ...this._def,
      shape: () => a
    });
  }
  keyof() {
    return Ge(k.objectKeys(this.shape));
  }
}
w.create = (n, e) => new w({
  shape: () => n,
  unknownKeys: "strip",
  catchall: P.create(),
  typeName: f.ZodObject,
  ...v(e)
});
w.strictCreate = (n, e) => new w({
  shape: () => n,
  unknownKeys: "strict",
  catchall: P.create(),
  typeName: f.ZodObject,
  ...v(e)
});
w.lazycreate = (n, e) => new w({
  shape: n,
  unknownKeys: "strip",
  catchall: P.create(),
  typeName: f.ZodObject,
  ...v(e)
});
class se extends _ {
  _parse(e) {
    const { ctx: a } = this._processInputParams(e), r = this._def.options;
    function s(i) {
      for (const l of i)
        if (l.result.status === "valid")
          return l.result;
      for (const l of i)
        if (l.result.status === "dirty")
          return a.common.issues.push(...l.ctx.common.issues), l.result;
      const o = i.map((l) => new E(l.ctx.common.issues));
      return p(a, {
        code: c.invalid_union,
        unionErrors: o
      }), y;
    }
    if (a.common.async)
      return Promise.all(r.map(async (i) => {
        const o = {
          ...a,
          common: {
            ...a.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await i._parseAsync({
            data: a.data,
            path: a.path,
            parent: o
          }),
          ctx: o
        };
      })).then(s);
    {
      let i;
      const o = [];
      for (const h of r) {
        const m = {
          ...a,
          common: {
            ...a.common,
            issues: []
          },
          parent: null
        }, b = h._parseSync({
          data: a.data,
          path: a.path,
          parent: m
        });
        if (b.status === "valid")
          return b;
        b.status === "dirty" && !i && (i = { result: b, ctx: m }), m.common.issues.length && o.push(m.common.issues);
      }
      if (i)
        return a.common.issues.push(...i.ctx.common.issues), i.result;
      const l = o.map((h) => new E(h));
      return p(a, {
        code: c.invalid_union,
        unionErrors: l
      }), y;
    }
  }
  get options() {
    return this._def.options;
  }
}
se.create = (n, e) => new se({
  options: n,
  typeName: f.ZodUnion,
  ...v(e)
});
const he = (n) => n instanceof le ? he(n.schema) : n instanceof A ? he(n.innerType()) : n instanceof ce ? [n.value] : n instanceof V ? n.options : n instanceof ue ? Object.keys(n.enum) : n instanceof de ? he(n._def.innerType) : n instanceof ne ? [void 0] : n instanceof re ? [null] : null;
class Te extends _ {
  _parse(e) {
    const { ctx: a } = this._processInputParams(e);
    if (a.parsedType !== d.object)
      return p(a, {
        code: c.invalid_type,
        expected: d.object,
        received: a.parsedType
      }), y;
    const r = this.discriminator, s = a.data[r], i = this.optionsMap.get(s);
    return i ? a.common.async ? i._parseAsync({
      data: a.data,
      path: a.path,
      parent: a
    }) : i._parseSync({
      data: a.data,
      path: a.path,
      parent: a
    }) : (p(a, {
      code: c.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [r]
    }), y);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(e, a, r) {
    const s = /* @__PURE__ */ new Map();
    for (const i of a) {
      const o = he(i.shape[e]);
      if (!o)
        throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);
      for (const l of o) {
        if (s.has(l))
          throw new Error(`Discriminator property ${String(e)} has duplicate value ${String(l)}`);
        s.set(l, i);
      }
    }
    return new Te({
      typeName: f.ZodDiscriminatedUnion,
      discriminator: e,
      options: a,
      optionsMap: s,
      ...v(r)
    });
  }
}
function Oe(n, e) {
  const a = B(n), r = B(e);
  if (n === e)
    return { valid: !0, data: n };
  if (a === d.object && r === d.object) {
    const s = k.objectKeys(e), i = k.objectKeys(n).filter((l) => s.indexOf(l) !== -1), o = { ...n, ...e };
    for (const l of i) {
      const h = Oe(n[l], e[l]);
      if (!h.valid)
        return { valid: !1 };
      o[l] = h.data;
    }
    return { valid: !0, data: o };
  } else if (a === d.array && r === d.array) {
    if (n.length !== e.length)
      return { valid: !1 };
    const s = [];
    for (let i = 0; i < n.length; i++) {
      const o = n[i], l = e[i], h = Oe(o, l);
      if (!h.valid)
        return { valid: !1 };
      s.push(h.data);
    }
    return { valid: !0, data: s };
  } else return a === d.date && r === d.date && +n == +e ? { valid: !0, data: n } : { valid: !1 };
}
class ie extends _ {
  _parse(e) {
    const { status: a, ctx: r } = this._processInputParams(e), s = (i, o) => {
      if (Ze(i) || Ze(o))
        return y;
      const l = Oe(i.value, o.value);
      return l.valid ? ((Ee(i) || Ee(o)) && a.dirty(), { status: a.value, value: l.data }) : (p(r, {
        code: c.invalid_intersection_types
      }), y);
    };
    return r.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: r.data,
        path: r.path,
        parent: r
      }),
      this._def.right._parseAsync({
        data: r.data,
        path: r.path,
        parent: r
      })
    ]).then(([i, o]) => s(i, o)) : s(this._def.left._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }), this._def.right._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }));
  }
}
ie.create = (n, e, a) => new ie({
  left: n,
  right: e,
  typeName: f.ZodIntersection,
  ...v(a)
});
class L extends _ {
  _parse(e) {
    const { status: a, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== d.array)
      return p(r, {
        code: c.invalid_type,
        expected: d.array,
        received: r.parsedType
      }), y;
    if (r.data.length < this._def.items.length)
      return p(r, {
        code: c.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), y;
    !this._def.rest && r.data.length > this._def.items.length && (p(r, {
      code: c.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), a.dirty());
    const i = [...r.data].map((o, l) => {
      const h = this._def.items[l] || this._def.rest;
      return h ? h._parse(new R(r, o, r.path, l)) : null;
    }).filter((o) => !!o);
    return r.common.async ? Promise.all(i).then((o) => C.mergeArray(a, o)) : C.mergeArray(a, i);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new L({
      ...this._def,
      rest: e
    });
  }
}
L.create = (n, e) => {
  if (!Array.isArray(n))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new L({
    items: n,
    typeName: f.ZodTuple,
    rest: null,
    ...v(e)
  });
};
class oe extends _ {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: a, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== d.object)
      return p(r, {
        code: c.invalid_type,
        expected: d.object,
        received: r.parsedType
      }), y;
    const s = [], i = this._def.keyType, o = this._def.valueType;
    for (const l in r.data)
      s.push({
        key: i._parse(new R(r, l, r.path, l)),
        value: o._parse(new R(r, r.data[l], r.path, l))
      });
    return r.common.async ? C.mergeObjectAsync(a, s) : C.mergeObjectSync(a, s);
  }
  get element() {
    return this._def.valueType;
  }
  static create(e, a, r) {
    return a instanceof _ ? new oe({
      keyType: e,
      valueType: a,
      typeName: f.ZodRecord,
      ...v(r)
    }) : new oe({
      keyType: Z.create(),
      valueType: e,
      typeName: f.ZodRecord,
      ...v(a)
    });
  }
}
class xe extends _ {
  _parse(e) {
    const { status: a, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== d.map)
      return p(r, {
        code: c.invalid_type,
        expected: d.map,
        received: r.parsedType
      }), y;
    const s = this._def.keyType, i = this._def.valueType, o = [...r.data.entries()].map(([l, h], m) => ({
      key: s._parse(new R(r, l, r.path, [m, "key"])),
      value: i._parse(new R(r, h, r.path, [m, "value"]))
    }));
    if (r.common.async) {
      const l = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const h of o) {
          const m = await h.key, b = await h.value;
          if (m.status === "aborted" || b.status === "aborted")
            return y;
          (m.status === "dirty" || b.status === "dirty") && a.dirty(), l.set(m.value, b.value);
        }
        return { status: a.value, value: l };
      });
    } else {
      const l = /* @__PURE__ */ new Map();
      for (const h of o) {
        const m = h.key, b = h.value;
        if (m.status === "aborted" || b.status === "aborted")
          return y;
        (m.status === "dirty" || b.status === "dirty") && a.dirty(), l.set(m.value, b.value);
      }
      return { status: a.value, value: l };
    }
  }
}
xe.create = (n, e, a) => new xe({
  valueType: e,
  keyType: n,
  typeName: f.ZodMap,
  ...v(a)
});
class W extends _ {
  _parse(e) {
    const { status: a, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== d.set)
      return p(r, {
        code: c.invalid_type,
        expected: d.set,
        received: r.parsedType
      }), y;
    const s = this._def;
    s.minSize !== null && r.data.size < s.minSize.value && (p(r, {
      code: c.too_small,
      minimum: s.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: s.minSize.message
    }), a.dirty()), s.maxSize !== null && r.data.size > s.maxSize.value && (p(r, {
      code: c.too_big,
      maximum: s.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: s.maxSize.message
    }), a.dirty());
    const i = this._def.valueType;
    function o(h) {
      const m = /* @__PURE__ */ new Set();
      for (const b of h) {
        if (b.status === "aborted")
          return y;
        b.status === "dirty" && a.dirty(), m.add(b.value);
      }
      return { status: a.value, value: m };
    }
    const l = [...r.data.values()].map((h, m) => i._parse(new R(r, h, r.path, m)));
    return r.common.async ? Promise.all(l).then((h) => o(h)) : o(l);
  }
  min(e, a) {
    return new W({
      ...this._def,
      minSize: { value: e, message: g.toString(a) }
    });
  }
  max(e, a) {
    return new W({
      ...this._def,
      maxSize: { value: e, message: g.toString(a) }
    });
  }
  size(e, a) {
    return this.min(e, a).max(e, a);
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
W.create = (n, e) => new W({
  valueType: n,
  minSize: null,
  maxSize: null,
  typeName: f.ZodSet,
  ...v(e)
});
class J extends _ {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(e) {
    const { ctx: a } = this._processInputParams(e);
    if (a.parsedType !== d.function)
      return p(a, {
        code: c.invalid_type,
        expected: d.function,
        received: a.parsedType
      }), y;
    function r(l, h) {
      return fe({
        data: l,
        path: a.path,
        errorMaps: [
          a.common.contextualErrorMap,
          a.schemaErrorMap,
          ge(),
          te
        ].filter((m) => !!m),
        issueData: {
          code: c.invalid_arguments,
          argumentsError: h
        }
      });
    }
    function s(l, h) {
      return fe({
        data: l,
        path: a.path,
        errorMaps: [
          a.common.contextualErrorMap,
          a.schemaErrorMap,
          ge(),
          te
        ].filter((m) => !!m),
        issueData: {
          code: c.invalid_return_type,
          returnTypeError: h
        }
      });
    }
    const i = { errorMap: a.common.contextualErrorMap }, o = a.data;
    return this._def.returns instanceof X ? I(async (...l) => {
      const h = new E([]), m = await this._def.args.parseAsync(l, i).catch((je) => {
        throw h.addIssue(r(l, je)), h;
      }), b = await o(...m);
      return await this._def.returns._def.type.parseAsync(b, i).catch((je) => {
        throw h.addIssue(s(b, je)), h;
      });
    }) : I((...l) => {
      const h = this._def.args.safeParse(l, i);
      if (!h.success)
        throw new E([r(l, h.error)]);
      const m = o(...h.data), b = this._def.returns.safeParse(m, i);
      if (!b.success)
        throw new E([s(m, b.error)]);
      return b.data;
    });
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...e) {
    return new J({
      ...this._def,
      args: L.create(e).rest(z.create())
    });
  }
  returns(e) {
    return new J({
      ...this._def,
      returns: e
    });
  }
  implement(e) {
    return this.parse(e);
  }
  strictImplement(e) {
    return this.parse(e);
  }
  static create(e, a, r) {
    return new J({
      args: e || L.create([]).rest(z.create()),
      returns: a || z.create(),
      typeName: f.ZodFunction,
      ...v(r)
    });
  }
}
class le extends _ {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: a } = this._processInputParams(e);
    return this._def.getter()._parse({ data: a.data, path: a.path, parent: a });
  }
}
le.create = (n, e) => new le({
  getter: n,
  typeName: f.ZodLazy,
  ...v(e)
});
class ce extends _ {
  _parse(e) {
    if (e.data !== this._def.value) {
      const a = this._getOrReturnCtx(e);
      return p(a, {
        received: a.data,
        code: c.invalid_literal,
        expected: this._def.value
      }), y;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
}
ce.create = (n, e) => new ce({
  value: n,
  typeName: f.ZodLiteral,
  ...v(e)
});
function Ge(n, e) {
  return new V({
    values: n,
    typeName: f.ZodEnum,
    ...v(e)
  });
}
class V extends _ {
  _parse(e) {
    if (typeof e.data != "string") {
      const a = this._getOrReturnCtx(e), r = this._def.values;
      return p(a, {
        expected: k.joinValues(r),
        received: a.parsedType,
        code: c.invalid_type
      }), y;
    }
    if (this._def.values.indexOf(e.data) === -1) {
      const a = this._getOrReturnCtx(e), r = this._def.values;
      return p(a, {
        received: a.data,
        code: c.invalid_enum_value,
        options: r
      }), y;
    }
    return I(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const a of this._def.values)
      e[a] = a;
    return e;
  }
  get Values() {
    const e = {};
    for (const a of this._def.values)
      e[a] = a;
    return e;
  }
  get Enum() {
    const e = {};
    for (const a of this._def.values)
      e[a] = a;
    return e;
  }
  extract(e) {
    return V.create(e);
  }
  exclude(e) {
    return V.create(this.options.filter((a) => !e.includes(a)));
  }
}
V.create = Ge;
class ue extends _ {
  _parse(e) {
    const a = k.getValidEnumValues(this._def.values), r = this._getOrReturnCtx(e);
    if (r.parsedType !== d.string && r.parsedType !== d.number) {
      const s = k.objectValues(a);
      return p(r, {
        expected: k.joinValues(s),
        received: r.parsedType,
        code: c.invalid_type
      }), y;
    }
    if (a.indexOf(e.data) === -1) {
      const s = k.objectValues(a);
      return p(r, {
        received: r.data,
        code: c.invalid_enum_value,
        options: s
      }), y;
    }
    return I(e.data);
  }
  get enum() {
    return this._def.values;
  }
}
ue.create = (n, e) => new ue({
  values: n,
  typeName: f.ZodNativeEnum,
  ...v(e)
});
class X extends _ {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: a } = this._processInputParams(e);
    if (a.parsedType !== d.promise && a.common.async === !1)
      return p(a, {
        code: c.invalid_type,
        expected: d.promise,
        received: a.parsedType
      }), y;
    const r = a.parsedType === d.promise ? a.data : Promise.resolve(a.data);
    return I(r.then((s) => this._def.type.parseAsync(s, {
      path: a.path,
      errorMap: a.common.contextualErrorMap
    })));
  }
}
X.create = (n, e) => new X({
  type: n,
  typeName: f.ZodPromise,
  ...v(e)
});
class A extends _ {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === f.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: a, ctx: r } = this._processInputParams(e), s = this._def.effect || null;
    if (s.type === "preprocess") {
      const o = s.transform(r.data);
      return r.common.async ? Promise.resolve(o).then((l) => this._def.schema._parseAsync({
        data: l,
        path: r.path,
        parent: r
      })) : this._def.schema._parseSync({
        data: o,
        path: r.path,
        parent: r
      });
    }
    const i = {
      addIssue: (o) => {
        p(r, o), o.fatal ? a.abort() : a.dirty();
      },
      get path() {
        return r.path;
      }
    };
    if (i.addIssue = i.addIssue.bind(i), s.type === "refinement") {
      const o = (l) => {
        const h = s.refinement(l, i);
        if (r.common.async)
          return Promise.resolve(h);
        if (h instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return l;
      };
      if (r.common.async === !1) {
        const l = this._def.schema._parseSync({
          data: r.data,
          path: r.path,
          parent: r
        });
        return l.status === "aborted" ? y : (l.status === "dirty" && a.dirty(), o(l.value), { status: a.value, value: l.value });
      } else
        return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((l) => l.status === "aborted" ? y : (l.status === "dirty" && a.dirty(), o(l.value).then(() => ({ status: a.value, value: l.value }))));
    }
    if (s.type === "transform")
      if (r.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: r.data,
          path: r.path,
          parent: r
        });
        if (!ye(o))
          return o;
        const l = s.transform(o.value, i);
        if (l instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: a.value, value: l };
      } else
        return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((o) => ye(o) ? Promise.resolve(s.transform(o.value, i)).then((l) => ({ status: a.value, value: l })) : o);
    k.assertNever(s);
  }
}
A.create = (n, e, a) => new A({
  schema: n,
  typeName: f.ZodEffects,
  effect: e,
  ...v(a)
});
A.createWithPreprocess = (n, e, a) => new A({
  schema: e,
  effect: { type: "preprocess", transform: n },
  typeName: f.ZodEffects,
  ...v(a)
});
class M extends _ {
  _parse(e) {
    return this._getType(e) === d.undefined ? I(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
M.create = (n, e) => new M({
  innerType: n,
  typeName: f.ZodOptional,
  ...v(e)
});
class F extends _ {
  _parse(e) {
    return this._getType(e) === d.null ? I(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
F.create = (n, e) => new F({
  innerType: n,
  typeName: f.ZodNullable,
  ...v(e)
});
class de extends _ {
  _parse(e) {
    const { ctx: a } = this._processInputParams(e);
    let r = a.data;
    return a.parsedType === d.undefined && (r = this._def.defaultValue()), this._def.innerType._parse({
      data: r,
      path: a.path,
      parent: a
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
de.create = (n, e) => new de({
  innerType: n,
  typeName: f.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ...v(e)
});
class ke extends _ {
  _parse(e) {
    const { ctx: a } = this._processInputParams(e), r = {
      ...a,
      common: {
        ...a.common,
        issues: []
      }
    }, s = this._def.innerType._parse({
      data: r.data,
      path: r.path,
      parent: {
        ...r
      }
    });
    return ve(s) ? s.then((i) => ({
      status: "valid",
      value: i.status === "valid" ? i.value : this._def.catchValue({
        get error() {
          return new E(r.common.issues);
        },
        input: r.data
      })
    })) : {
      status: "valid",
      value: s.status === "valid" ? s.value : this._def.catchValue({
        get error() {
          return new E(r.common.issues);
        },
        input: r.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
ke.create = (n, e) => new ke({
  innerType: n,
  typeName: f.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ...v(e)
});
class we extends _ {
  _parse(e) {
    if (this._getType(e) !== d.nan) {
      const r = this._getOrReturnCtx(e);
      return p(r, {
        code: c.invalid_type,
        expected: d.nan,
        received: r.parsedType
      }), y;
    }
    return { status: "valid", value: e.data };
  }
}
we.create = (n) => new we({
  typeName: f.ZodNaN,
  ...v(n)
});
const zt = Symbol("zod_brand");
class He extends _ {
  _parse(e) {
    const { ctx: a } = this._processInputParams(e), r = a.data;
    return this._def.type._parse({
      data: r,
      path: a.path,
      parent: a
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class pe extends _ {
  _parse(e) {
    const { status: a, ctx: r } = this._processInputParams(e);
    if (r.common.async)
      return (async () => {
        const i = await this._def.in._parseAsync({
          data: r.data,
          path: r.path,
          parent: r
        });
        return i.status === "aborted" ? y : i.status === "dirty" ? (a.dirty(), Fe(i.value)) : this._def.out._parseAsync({
          data: i.value,
          path: r.path,
          parent: r
        });
      })();
    {
      const s = this._def.in._parseSync({
        data: r.data,
        path: r.path,
        parent: r
      });
      return s.status === "aborted" ? y : s.status === "dirty" ? (a.dirty(), {
        status: "dirty",
        value: s.value
      }) : this._def.out._parseSync({
        data: s.value,
        path: r.path,
        parent: r
      });
    }
  }
  static create(e, a) {
    return new pe({
      in: e,
      out: a,
      typeName: f.ZodPipeline
    });
  }
}
const Je = (n, e = {}, a) => n ? Y.create().superRefine((r, s) => {
  var i, o;
  if (!n(r)) {
    const l = typeof e == "function" ? e(r) : typeof e == "string" ? { message: e } : e, h = (o = (i = l.fatal) !== null && i !== void 0 ? i : a) !== null && o !== void 0 ? o : !0, m = typeof l == "string" ? { message: l } : l;
    s.addIssue({ code: "custom", ...m, fatal: h });
  }
}) : Y.create(), Ut = {
  object: w.lazycreate
};
var f;
(function(n) {
  n.ZodString = "ZodString", n.ZodNumber = "ZodNumber", n.ZodNaN = "ZodNaN", n.ZodBigInt = "ZodBigInt", n.ZodBoolean = "ZodBoolean", n.ZodDate = "ZodDate", n.ZodSymbol = "ZodSymbol", n.ZodUndefined = "ZodUndefined", n.ZodNull = "ZodNull", n.ZodAny = "ZodAny", n.ZodUnknown = "ZodUnknown", n.ZodNever = "ZodNever", n.ZodVoid = "ZodVoid", n.ZodArray = "ZodArray", n.ZodObject = "ZodObject", n.ZodUnion = "ZodUnion", n.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", n.ZodIntersection = "ZodIntersection", n.ZodTuple = "ZodTuple", n.ZodRecord = "ZodRecord", n.ZodMap = "ZodMap", n.ZodSet = "ZodSet", n.ZodFunction = "ZodFunction", n.ZodLazy = "ZodLazy", n.ZodLiteral = "ZodLiteral", n.ZodEnum = "ZodEnum", n.ZodEffects = "ZodEffects", n.ZodNativeEnum = "ZodNativeEnum", n.ZodOptional = "ZodOptional", n.ZodNullable = "ZodNullable", n.ZodDefault = "ZodDefault", n.ZodCatch = "ZodCatch", n.ZodPromise = "ZodPromise", n.ZodBranded = "ZodBranded", n.ZodPipeline = "ZodPipeline";
})(f || (f = {}));
const qt = (n, e = {
  message: `Input not instance of ${n.name}`
}) => Je((a) => a instanceof n, e), Ye = Z.create, Xe = Q.create, Wt = we.create, Ft = D.create, Ke = ae.create, Gt = q.create, Ht = _e.create, Jt = ne.create, Yt = re.create, Xt = Y.create, Kt = z.create, ea = P.create, ta = be.create, aa = O.create, na = w.create, ra = w.strictCreate, sa = se.create, ia = Te.create, oa = ie.create, la = L.create, ca = oe.create, ua = xe.create, da = W.create, pa = J.create, ma = le.create, ha = ce.create, ga = V.create, fa = ue.create, ya = X.create, qe = A.create, va = M.create, _a = F.create, ba = A.createWithPreprocess, xa = pe.create, ka = () => Ye().optional(), wa = () => Xe().optional(), Ta = () => Ke().optional(), Sa = {
  string: (n) => Z.create({ ...n, coerce: !0 }),
  number: (n) => Q.create({ ...n, coerce: !0 }),
  boolean: (n) => ae.create({
    ...n,
    coerce: !0
  }),
  bigint: (n) => D.create({ ...n, coerce: !0 }),
  date: (n) => q.create({ ...n, coerce: !0 })
}, $a = y;
var t = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: te,
  setErrorMap: Zt,
  getErrorMap: ge,
  makeIssue: fe,
  EMPTY_PATH: Et,
  addIssueToContext: p,
  ParseStatus: C,
  INVALID: y,
  DIRTY: Fe,
  OK: I,
  isAborted: Ze,
  isDirty: Ee,
  isValid: ye,
  isAsync: ve,
  get util() {
    return k;
  },
  get objectUtil() {
    return Ie;
  },
  ZodParsedType: d,
  getParsedType: B,
  ZodType: _,
  ZodString: Z,
  ZodNumber: Q,
  ZodBigInt: D,
  ZodBoolean: ae,
  ZodDate: q,
  ZodSymbol: _e,
  ZodUndefined: ne,
  ZodNull: re,
  ZodAny: Y,
  ZodUnknown: z,
  ZodNever: P,
  ZodVoid: be,
  ZodArray: O,
  ZodObject: w,
  ZodUnion: se,
  ZodDiscriminatedUnion: Te,
  ZodIntersection: ie,
  ZodTuple: L,
  ZodRecord: oe,
  ZodMap: xe,
  ZodSet: W,
  ZodFunction: J,
  ZodLazy: le,
  ZodLiteral: ce,
  ZodEnum: V,
  ZodNativeEnum: ue,
  ZodPromise: X,
  ZodEffects: A,
  ZodTransformer: A,
  ZodOptional: M,
  ZodNullable: F,
  ZodDefault: de,
  ZodCatch: ke,
  ZodNaN: we,
  BRAND: zt,
  ZodBranded: He,
  ZodPipeline: pe,
  custom: Je,
  Schema: _,
  ZodSchema: _,
  late: Ut,
  get ZodFirstPartyTypeKind() {
    return f;
  },
  coerce: Sa,
  any: Xt,
  array: aa,
  bigint: Ft,
  boolean: Ke,
  date: Gt,
  discriminatedUnion: ia,
  effect: qe,
  enum: ga,
  function: pa,
  instanceof: qt,
  intersection: oa,
  lazy: ma,
  literal: ha,
  map: ua,
  nan: Wt,
  nativeEnum: fa,
  never: ea,
  null: Yt,
  nullable: _a,
  number: Xe,
  object: na,
  oboolean: Ta,
  onumber: wa,
  optional: va,
  ostring: ka,
  pipeline: xa,
  preprocess: ba,
  promise: ya,
  record: ca,
  set: da,
  strictObject: ra,
  string: Ye,
  symbol: Ht,
  transformer: qe,
  tuple: la,
  undefined: Jt,
  union: sa,
  unknown: Kt,
  void: ta,
  NEVER: $a,
  ZodIssueCode: c,
  quotelessJson: It,
  ZodError: E
});
const x = (n) => u`
  "${n}": coalesce(
    ${n}[$language],
    coalesce(${n}['en'], coalesce(${n}, ''))
  )`, Nr = (n) => u`
  "${n}": coalesce(
    ${n}[$language],
    ${n}["en"],
    []
  )`, Rr = (n) => u`
  "${n}": ${n}[]{
    "text": coalesce(@[$language], @["en"])
  }`, N = (n) => u`
  "${n}":coalesce(
    ${n}[$language],
    coalesce(${n}['en'], coalesce(${n}, {}))
    )`, Se = t.object({
  label: t.string(),
  linkType: t.enum(["default", "page", "internalModal", "externalModal"]),
  shouldDisplayAsButton: t.boolean(),
  variant: t.enum(["Standard", "Secondary-cta", "Subtle", "Inverted"]),
  url: t.string(),
  target: t.enum(["_blank", "_self"]),
  iconType: t.string(),
  iconPosition: t.enum(["left", "right"]),
  _type: t.literal("atLink")
}), U = u`
{
  ${x("label")},
  _type,
  "type": _type,
  linkType,
  shouldDisplayAsButton,
  variant,
  "iconType": coalesce(iconType, ""),
  "iconPosition": coalesce(iconPosition, "left"),
  "target": coalesce(
    select(
      (linkType == 'default' || linkType == 'page') => target,
      "_self"
    ),
    "_self"
  ),
  "url": coalesce(
    select(
      linkType == 'default' || linkType == 'externalModal' => url,
      linkType == 'page' || linkType == 'internalModal' => pageReference->slug.current
    ),
    ""
  )
}`, Ca = t.object({
  _type: t.literal("image"),
  asset: t.object({
    _ref: t.string(),
    _type: t.literal("reference")
  }),
  crop: t.optional(
    t.object({
      left: t.number(),
      bottom: t.number(),
      _type: t.literal("sanity.imageCrop"),
      right: t.number(),
      top: t.number()
    })
  ),
  hotspot: t.optional(
    t.object({
      height: t.number(),
      _type: t.literal("sanity.imageHotspot"),
      width: t.number(),
      x: t.number(),
      y: t.number()
    })
  )
}), S = t.object({
  alt: t.string(),
  src: t.string(),
  quality: t.number(),
  type: t.literal("atImage"),
  imageRecord: Ca,
  width: t.number(),
  height: t.number(),
  title: t.string()
}), $ = u`{
  "type": _type,
  "alt": coalesce(image.asset-> altText, alt, ''),
  "quality": coalesce(quality, 75),
  // Image Record includes hotspot & crop information, used for picture elements
  "imageRecord": image,
  // Fallback for components not using a picture elements, we pull the image src, optimize to webp and ensure a minimum quality
  "src": image.asset->url + '?auto=format' + '&q=' + coalesce(string(quality), '75'), 
  "width": image.asset->metadata.dimensions.width,
  "height": image.asset->metadata.dimensions.height,
  "title": coalesce(image.asset-> title, image.asset -> originalFilename, ''),
}`, ja = t.object({
  _type: t.literal("imageContainer"),
  imageContainer: t.array(S)
}), Ia = u`{
   _type,
  "imageContainer": imageContainer[]${$},
}`, Za = t.object({
  _type: t.literal("phone"),
  number: t.string()
}), Ea = t.object({
  _type: t.literal("table"),
  rows: t.array(
    t.object({
      _type: t.literal("tableRow"),
      cells: t.array(t.string())
    })
  )
}), Oa = Se.pick({
  linkType: !0,
  target: !0,
  url: !0
}).extend({
  _key: t.string(),
  _type: t.string(),
  type: t.string()
}), Aa = t.object({
  _key: t.string(),
  _type: t.literal("fragmentId"),
  fragmentId: t.string()
}), Na = t.object({
  _key: t.string(),
  _type: t.literal("textColor"),
  label: t.string(),
  value: t.string()
}), et = t.object({
  _type: t.literal("block"),
  style: t.string(),
  children: t.array(
    t.object({
      text: t.string(),
      _type: t.string(),
      marks: t.array(t.string()).optional()
    })
  ),
  markDefs: t.array(
    t.union([Oa, Aa, Na])
  ).optional(),
  listItem: t.optional(t.union([t.literal("bullet"), t.literal("number")])),
  level: t.optional(t.number())
}), j = t.union([
  Za,
  Ea,
  et,
  Se,
  ja
]), T = u`{
	_type,
	listItem != null => {
		  listItem
    },
	level != null => {
		level
	},
	_type == 'atLink' => ${U},
	_type == 'phone' => {"number":coalesce(
			{...}[$country],
			select($country in ['ca', 'us'] => nam),
			emea,
			global
		)},
	_type == 'table' => {
		_type,
		rows[]{
			_type,
			cells,
		},
	},
	_type == 'imageContainer' => ${Ia},
	_type == 'block' => {
		style,
		"children": children[]{
		  ...,
		  marks != null => {
			  marks,
		  },
	  },
	  markDefs != null => {
	    "markDefs": markDefs[]{
		    _key,
		    "type": _type,
		    _type == 'link' => ${U},
		    _type == 'fragmentId' => {...},
		    _type == 'textColor' => {...},
	    },
	  },
	},
}`, Ra = t.object({
  alertType: t.string(),
  content: t.array(j),
  paths: t.array(t.string())
}), La = u`
{
    "alertType": coalesce(alertType, "advisory"),
    "content": coalesce(
        content.[$language][]${T},
        content.['en'][]${T}),
    "paths": [...paths, ...customPaths] 

}
`, Ma = u`*[
    _type == 'alertBanner' &&
    (
        $slug in paths || $slug in customPaths
    )  && $market match market
  ][    
    region == $country || 
    region == select($country in ['ca', 'us'] => 'nam', 'emea') ||
    region == 'global'
   ]
   | order(_updatedAt desc)[0]`, Lr = async (n, e) => {
  const a = u`${Ma}${La}`, r = Re(e);
  try {
    const s = await n.fetch(a, r);
    return s ? Ra.parse(s) : null;
  } catch (s) {
    throw s instanceof Error ? new Error(s.message) : new Error("An unknown error occurred");
  }
}, Pa = t.object({
  items: t.array(Se)
}), Ba = u`{
  "items": items[]${U}
}`, K = t.object({
  content: t.array(j),
  type: t.literal("mlRichTextContainer"),
  textAlign: t.enum(["left", "center", "right"]),
  spacing: t.enum(["0rem", "1rem", "1.5rem", "2rem", "3rem"])
}), ee = u`{
  "type": _type,
  "content":
    coalesce(
      richText[$language][]${T},
      richText['en'][]${T},
      richText[]${T},
    ),
  "textAlign": coalesce(textAlign, "left"),
  "spacing": coalesce(spacing, "1.5rem")
  }`, Qa = t.object({
  type: t.literal("mlAnnouncement"),
  iconType: t.string(),
  content: t.array(j)
}), Da = u`{
  "type": _type,
  iconType,
	${N("content")}[] {
    ...${T},
  },
	}`, Va = t.union([Qa, K]), za = u`{
  _type == 'mlAnnouncement' => ${Da},
  _type == 'mlRichTextContainer' => ${ee}
  }`, tt = [
  "lag-gb",
  "lag-us",
  "lag-nl",
  "lag-ch",
  "lag-se",
  "lag-es",
  "lag-pl",
  "lag-no",
  "lag-kr",
  "lag-jp",
  "flag-it",
  "flag-ie",
  "flag-hu",
  "flag-de",
  "flag-fr",
  "flag-fi",
  "flag-eu",
  "flag-dk",
  "flag-cz",
  "flag-cn",
  "flag-ca",
  "flag-be",
  "flag-at",
  "flag-au",
  "apple-pay-logo",
  "google-pay-logo",
  "visa-logo",
  "mastercard-logo",
  "amex-logo",
  "klarna-logo-bw",
  "klarna-logo",
  "svs-logo",
  "paypal-logo",
  "email",
  "secure-icon",
  "question-mark",
  "caret-down",
  "success-icon",
  "info-icon",
  "warning-icon",
  "caution-icon",
  "star",
  "left-arrow",
  "right-arrow",
  "up-arrow",
  "down-arrow",
  "plus-icon",
  "minus-icon",
  "remove-icon",
  "user",
  "arcteryx-logo",
  "arcteryx-logo-no-text",
  "arcteryx-logo-outlet",
  "ship-to-address-icon",
  "leaving-checkout-icon",
  "shipping-method-loading-icon",
  "pickup-icon",
  "cart",
  "link",
  "play-button",
  "free-shipping-icon",
  "free-returns-icon",
  "limited-warranty-icon",
  "ruler",
  "product-service",
  "product-care",
  "product-return",
  "product-manuals",
  "shipping-delivery",
  "order-tracking",
  "faq",
  "pro",
  "counterfeit",
  "alpha-sv",
  "clock",
  "region",
  "tree",
  "globe-2",
  "mountain",
  "sun",
  "customer-support",
  "download-icon",
  "number-1",
  "number-2",
  "number-3",
  "number-4",
  "number-5",
  "pick-up-in-store",
  "std-shipping-regular",
  "alpha-pf-svg",
  "beta-pf-svg",
  "delta-pf-svg",
  "epsilon-pf-svg",
  "gamma-pf-svg",
  "rho-pf-svg",
  "sigma-pf-svg",
  "theta-pf-svg",
  "zeta-pf-svg",
  "alpha-alt-pf-svg",
  "beta-alt-pf-svg",
  "delta-alt-pf-svg",
  "epsilon-alt-pf-svg",
  "rho-alt-pf-svg",
  "sigma-alt-pf-svg",
  "theta-alt-pf-svg",
  "zeta-alt-pf-svg",
  "proton-pf-minor-svg",
  "atom-pf-minor-svg",
  "rebird-alt-pf-minor-svg",
  "rebird-pf-minor-svg",
  "bora-pf-minor-svg",
  "satoro-pf-minor-svg",
  "cerium-pf-minor-svg",
  "thorium-pf-minor-svg",
  "fission-pf-minor-svg",
  "incendo-pf-minor-svg",
  "motus-pf-minor-svg",
  "phase-pf-minor-svg",
  "norvan-pf-minor-svg",
  "procline-pf-minor-svg",
  "a2b-pf-minor-svg",
  "a2b-alt-pf-minor-svg",
  "proton-alt-pf-minor-svg",
  "atom-alt-pf-minor-svg",
  "bora-alt-pf-minor-svg",
  "satoro-alt-pf-minor-svg",
  "thorium-alt-pf-minor-svg",
  "cerium-alt-pf-minor-svg",
  "fission-alt-pf-minor-svg",
  "incendo-alt-pf-minor-svg",
  "phase-alt-pf-minor-svg",
  "norvan-alt-pf-minor-svg",
  "procline-alt-pf-minor-svg",
  "natural-ft-svg",
  "softshell-ft-svg",
  "synthetic-ft-svg",
  "waterproof-ft-svg",
  "windproof-ft-svg",
  "fairtrade-ft-svg",
  "breathable-ft-svg",
  "composite-ft-svg",
  "dope-ft-svg",
  "down-ft-svg",
  "durable-ft-svg",
  "hardshell-ft-svg",
  "lightweight-ft-svg",
  "material-ft-svg",
  "balance-ft-svg",
  "balance-alt-ft-svg",
  "natural-alt-ft-svg",
  "synthetic-alt-ft-svg",
  "upf-alt-ft-svg",
  "waterproof-alt-ft-svg",
  "windproof-alt-ft-svg",
  "breathable-alt-ft-svg",
  "composite-alt-ft-svg",
  "down-alt-ft-svg",
  "durable-alt-ft-svg",
  "lightweight-alt-ft-svg",
  "material-alt-ft-svg",
  "sk-pm-svg",
  "superlight-pm-svg",
  "severe-pm-svg",
  "vertical-pm-svg",
  "warp-pm-svg",
  "allround-pm-svg",
  "comp-pm-svg",
  "fastlight-pm-svg",
  "insulated-pm-svg",
  "longdistance-pm-svg",
  "lightweight-pm-svg",
  "ltw-pm-svg",
  "mixedweather-pm-svg",
  "ac2-pm-svg",
  "sk-alt-pm-svg",
  "superlight-alt-pm-svg",
  "severe-alt-pm-svg",
  "vertical-alt-pm-svg",
  "warp-alt-pm-svg",
  "allround-alt-pm-svg",
  "comp-alt-pm-svg",
  "fastlight-alt-pm-svg",
  "insulated-alt-pm-svg",
  "longdistance-alt-pm-svg",
  "lightweight-alt-pm-svg",
  "ltw-alt-pm-svg",
  "mixedweather-alt-pm-svg",
  "ac2-alt-pm-svg",
  "hiplen-sf-svg",
  "regularfit-sf-svg",
  "regularlen-sf-svg",
  "relaxedfit-sf-svg",
  "slimfit-sf-svg",
  "thighlen-sf-svg",
  "fitsize-alt-sf-svg",
  "fitsize-sf-svg",
  "hiplen-alt-sf-svg",
  "regularfit-alt-sf-svg",
  "regularlen-alt-sf-svg",
  "relaxedfit-alt-sf-svg",
  "slimfit-alt-sf-svg",
  "thighlen-alt-sf-svg",
  "coldwet-pw-svg",
  "mild-pw-svg",
  "variable-pw-svg",
  "warmdry-pw-svg",
  "warmwet-pw-svg",
  "wet-pw-svg",
  "colddry-pw-svg",
  "colddry-alt-pw-svg",
  "coldwet-alt-pw-svg",
  "mild-alt-pw-svg",
  "variable-alt-pw-svg",
  "warmdry-alt-pw-svg",
  "warmwet-alt-pw-svg",
  "wet-alt-pw-svg",
  "alpine-act-svg",
  "alpine-alt-act-svg",
  "everyday-act-svg",
  "everyday-alt-act-svg",
  "hiking-act-svg",
  "hiking-alt-act-svg",
  "multiuse-act-svg",
  "multiuse-alt-act-svg",
  "skiing-act-svg",
  "skiing-alt-act-svg",
  "system-act-svg",
  "system-alt-act-svg",
  "trailrun-act-svg",
  "trailrun-alt-act-svg",
  "veilance-act-svg",
  "veilance-alt-act-svg"
], at = t.object({
  icon: t.enum(tt),
  content: t.array(j),
  type: t.literal("mlRichTextIcon")
}), nt = u`{
    "icon": icon,
    "content": coalesce(content.[$language][]${T}, content.['en'][]${T}),
    "type": _type,
  }`, Ua = t.object({
  type: t.literal("orBoxListImage"),
  image: S,
  displayImageBelowMd: t.boolean(),
  items: t.array(t.union([at, K]))
}), qa = u`{
    "type": _type,
    "image": image${$},
    "displayImageBelowMd": coalesce(displayImageBelowMd, true),
    "items": items[]{
      _type == 'mlRichTextIcon' => ${nt},
      _type == 'mlRichTextContainer' => ${ee},
    },
}`, Le = t.object({
  title: t.string(),
  type: t.literal("mlCard"),
  button: Se,
  content: t.array(j),
  image: S,
  variant: t.enum(["product", "image", "dynamic", "video"])
}), Me = u`{
  ${x("title")},
  "button": button${U},
  ${N("content")}[] {
    ...${T},
  },
  "type": _type,
  "image": image${$},
  variant,
}`, Pe = t.object({
  type: t.literal("videoCard"),
  content: t.array(j),
  isMuted: t.boolean(),
  shouldAutoPlay: t.boolean(),
  shouldLoop: t.boolean(),
  shouldPlayInLine: t.boolean(),
  source: t.string()
}), Be = u`{
  ...,
  ${N("content")}[] {
    ...${T},
  },
  "type": _type,
}`, rt = t.object({
  type: t.literal("orCarousel"),
  title: t.string().optional(),
  items: t.array(t.union([S, Le, Pe])),
  justifyContent: t.enum(["flex-start", "center", "flex-end"])
}), st = u`{
  "type": _type,
  ${x("title")},
  items[]{
    _type == 'atImage' => ${$},
    _type == 'mlCard' => ${Me},
    _type == 'videoCard' => ${Be},
  },
  "justifyContent": coalesce(justifyContent, 'center'),
}`, it = t.object({
  type: t.literal("orCenteredImage"),
  title: t.string().optional(),
  image: S,
  backgroundColorHex: t.string()
}), ot = u`{
  "image": image${$},
  "type": _type,
  ${x("title")},
  "backgroundColorHex": coalesce(colorPicker.hex, '#ffffff')
}`, lt = t.object({
  type: t.literal("orCollapseGroup"),
  title: t.string().optional(),
  items: t.array(t.object({
    title: t.string(),
    content: t.array(j),
    headingLevel: t.enum(["1", "2", "3", "4", "5"])
  }))
}), ct = u`{
 	"type": _type,
  ${x("title")},
  "items": items[] {
    ${x("title")},
    "headingLevel": coalesce( string(^.headingLevel), "2"),
    ${N("content")}[] {
    ...${T},
  },
  },
}`, Qe = t.object({
  columnCount: t.number(),
  breakpoint: t.string()
}), De = u`{
		columnCount,
		breakpoint
		}`, Wa = t.object({
  type: t.literal("atDivider")
}), Fa = u`{
    "type": _type,
}`, Ve = t.object({
  type: t.literal("mlFullWidthCard"),
  content: t.nullable(t.array(j)),
  image: S,
  textAlign: t.enum(["left", "center", "right"]),
  imageVariant: t.enum(["default", "tall", "square"])
}), ze = u`{
  ${N("content")}[] {
    ...${T},
  },
  "type": _type,
  "image": image${$},
  "textAlign": coalesce(textAlign, "left"),
  "imageVariant": coalesce(imageVariant, "default"),
}`, $e = t.object({
  type: t.literal("mlFullWidthImage"),
  image: S
}), Ce = u`{
  "image": image${$},
  "type": _type,
}`, Ga = t.object({
  type: t.literal("atGoogleMap"),
  mapId: t.string()
}), Ha = u`{
  "type": _type,
  "mapId": coalesce(mapId, ""),
}`, ut = t.object({
  headline: t.string(),
  image: S,
  isTextShadowApplied: t.boolean(),
  miceType: t.string(),
  textArea: t.string(),
  type: t.literal("orHeroBanner")
}), dt = u`{
  ${x("headline")},
  "image": image${$},
  "isTextShadowApplied": coalesce(isTextShadowApplied, false),
  ${x("miceType")},
  ${x("textArea")},
  "type": _type,
}`, Ja = t.object({
  type: t.literal("orContainer"),
  fullWidthContainer: t.boolean(),
  justifyItems: t.enum(["flex-start", "center", "flex-end"]),
  columnBreakpoints: t.array(Qe),
  sections: t.array(t.union([$e, K, Ve]))
}), Ya = u`{
    "type": _type,
    "fullWidthContainer": coalesce(fullWidthContainer, false),
    "justifyItems": coalesce(justifyItems, 'flex-start'),
    "columnBreakpoints": coalesce(columnBreakpoints[]${De}, []),
    "sections": items[]{
      _type == 'mlRichTextContainer' => ${ee},
      _type == 'mlFullWidthImage' => ${Ce},
      _type == 'mlFullWidthCard' => ${ze}
    }
}`, Xa = t.object({
  type: t.literal("orIconAccordion"),
  accordionTitle: t.string(),
  sections: t.array(Ja)
}), Ka = u`{
    "type": _type,
    ${x("accordionTitle")},
    "sections": sections[]${Ya}
}`, en = t.object({
  type: t.literal("mlImageTextLinkBox"),
  image: $e,
  label: t.string(),
  url: t.string(),
  target: t.enum(["_blank", "_self"])
}), tn = u`{
  "type": _type,
  "image": image${Ce},
   ${x("label")},
  "url": coalesce(url,  ""),
  "target": coalesce(target, "_blank"),
}`, an = t.object({
  type: t.literal("atCareersJobListing"),
  department: t.enum(["retail", "corporate", "manufacturing"])
}), nn = u`{
  "type": _type,
  "department": coalesce(department, 'retail')
}`, rn = t.object({
  type: t.literal("orMediumHeroBanner"),
  image: S,
  richText: t.array(j)
}), sn = u`{
    "type": _type,
    "image": image${$},
    "richText": coalesce(translations[$language], translations.en)
}`, pt = t.object({
  icon: t.string(),
  label: t.string(),
  url: t.string(),
  target: t.enum(["_blank", "_self"]),
  type: t.literal("mlLinkBox")
}), mt = u`{
"type": _type,
${x("label")},
url,
icon,
"target": coalesce(target, "_self"),
}`, on = t.object({
  description: t.string(),
  label: t.string(),
  measuringType: t.string(),
  table: t.array(t.array(t.string())),
  type: t.literal("smTableSizing")
}), ln = u`{
  "type": _type,
  ${x("description")},
  label,
  ${x("measuringType")},
  "table":  coalesce(table[$language].rows[].cells, table['en'].rows[].cells, []),
  }`, ht = t.object({
  title: t.string(),
  type: t.literal("orTable"),
  category: t.string(),
  disclaimer: t.string(),
  tables: t.array(on)
}), gt = u`{
  "type": _type,
  ${x("category")},
  ${x("disclaimer")},
  ${x("title")},
  "tables": tables[]->${ln}
}`, ft = t.object({
  type: t.literal("mlTextImage"),
  image: S,
  textItems: t.array(K),
  imageSize: t.enum(["small", "medium"]),
  displayImageBelowMd: t.boolean(),
  isImageOnLeft: t.boolean()
}), yt = u`{
    "type": _type,
    "image": image${$},
    "textItems": textItems[]{
        _type == 'mlRichTextContainer' => ${ee},
        },
    "imageSize": coalesce(imageSize, "medium"),
    "displayImageBelowMd": coalesce(displayImageBelowMd, true),
    "isImageOnLeft": coalesce(isImageOnLeft, false),
    }
`, cn = t.union(
  [
    lt,
    pt,
    K,
    ht,
    Le,
    Pe,
    it,
    ft,
    rt,
    $e,
    Ve
  ]
), un = t.object({
  columnBreakpoints: t.array(Qe),
  name: t.string(),
  sections: t.array(cn),
  type: t.string()
}), dn = u`{
  "type": _type,
  "columnBreakpoints": coalesce(columnBreakpoints[]${De}, []),
  name,
  "sections": items[]{
    _type == 'mlLinkBox' => ${mt},
    _type == 'mlRichTextContainer' => ${ee},
    _type == 'orCollapseGroup' => ${ct},
    _type == 'orTable' => ${gt},
    _type == 'mlCard' => ${Me},
    _type == 'videoCard' => ${Be},
    _type == 'orCenteredImage' => ${ot},
    _type == 'mlTextImage' => ${yt},
    _type == 'orCarousel' => ${st},
    _type == 'mlFullWidthImage' => ${Ce},
    _type == 'mlFullWidthCard' => ${ze},
   },
  }`, pn = t.object({
  label: t.string(),
  title: t.string().optional(),
  category: t.string().optional(),
  type: t.string(),
  sections: t.array(un)
}), mn = u`{
  "type": _type,
  ${x("label")},
  ${x("title")},
  ${x("category")},
  "sections": sections[]${dn},
  }`, hn = t.object({
  type: t.literal("orTabList"),
  tabs: t.array(pn)
}), gn = u`{
  "type": _type,
  "tabs": tabs[]${mn},
  }`, fn = t.enum(["CO", "AR", "AM", "PR", "IN", "LX"]), yn = t.object({
  content: t.array(
    t.object({
      groupType: t.array(fn),
      content: t.array(j)
    })
  ),
  type: t.literal("mlRichTextGroupType")
}), vn = u`
{
  "type": _type,
  "content": content[]{
    "groupType": coalesce(groupType, ['CO']),
    ${N("content")}[] {
      ...${T},
    },
  },
}
`, _n = t.object({
  type: t.literal("orShortHeroBanner"),
  image: S
}), bn = u`{
  "type": _type,
  "image": image${$},
}`, xn = t.object({
  type: t.literal("mlVideoThumbnail"),
  image: S,
  title: t.string(),
  subtitle: t.string(),
  isPlayButtonEnabled: t.boolean(),
  playButtonColour: t.string(),
  textColour: t.string(),
  isThumbnailGradientEnabled: t.boolean()
}), kn = u`{
    "type": _type,
    "image": image${$},
    ${x("title")},
    ${x("subtitle")},
    "isPlayButtonEnabled": coalesce(isPlayButtonEnabled, true),
    "playButtonColour": coalesce(playButtonColour, '#FFFFFF'),
    "textColour": coalesce(colorPicker.hex, '#FFFFFF'),
    "isThumbnailGradientEnabled": coalesce(isThumbnailGradientEnabled, false),
}`, wn = t.object({
  type: t.literal("orVideo"),
  isAutoPlayed: t.boolean(),
  isMuted: t.boolean(),
  videoSrc: t.string(),
  videoThumbnail: xn
}), Tn = u`{
    "type":_type,
    "isAutoPlayed": coalesce(isAutoPlayed, false),
    "isMuted": coalesce(isMuted, true),
    videoSrc,
    "videoThumbnail": videoThumbnail${kn},
}`, Sn = t.union([
  Ua,
  Le,
  lt,
  ut,
  pt,
  hn,
  K,
  _n,
  ht,
  ft
]), $n = t.union([
  rt,
  it,
  Wa,
  Ve,
  $e,
  Ga,
  Xa,
  en,
  an,
  rn,
  yn,
  at,
  Pe,
  wn
]), Cn = t.union([Sn, $n]), vt = t.object({
  columnBreakpoints: t.array(Qe),
  fullWidthContainer: t.boolean(),
  justifyItems: t.enum(["flex-start", "center", "flex-end"]),
  name: t.string(),
  sections: t.array(Cn),
  type: t.literal("orContainer")
}), _t = u`{
  "type": _type,
  "columnBreakpoints": coalesce(columnBreakpoints[]${De}, []),
  "fullWidthContainer": coalesce(fullWidthContainer, false),
  "justifyItems": coalesce(justifyItems, 'flex-start'),
  name,
  "sections": items[]{
    // We should be able to make this an optional query, where we don't accept 
    // the tablist if it is the tablist . 
    _type == 'orHeroBanner' => ${dt},
    _type == 'orShortHeroBanner' => ${bn},
    _type == 'mlLinkBox' => ${mt},
    _type == 'mlRichTextContainer' => ${ee},
    _type == 'orCollapseGroup' => ${ct},
    _type == 'orTabList' => ${gn},
    _type == 'orTable' => ${gt},
    _type == 'mlCard' => ${Me},
    _type == 'videoCard' => ${Be},
    _type == 'mlTextImage' => ${yt},
    _type == 'orBoxListImage' => ${qa},
    _type == 'orCenteredImage' => ${ot},
    _type == 'mlFullWidthCard' => ${ze},
    _type == 'mlFullWidthImage' => ${Ce},
    _type == 'orCarousel' => ${st},
    _type == 'atCareersJobListing' => ${nn},
    _type == 'orVideo' => ${Tn},
    _type == 'atGoogleMap' => ${Ha},
    _type == 'mlRichTextIcon' => ${nt},
    _type == 'atDivider' => ${Fa},
    _type == 'orIconAccordion' => ${Ka},
    _type == 'orMediumHeroBanner' => ${sn},
    _type == 'mlRichTextGroupType' => ${vn},
    _type == 'mlImageTextLinkBox' => ${tn},
    },
  }`, jn = t.object({
  icon: t.enum(tt),
  content: t.array(j)
}), In = u`{
  "icon": richTextIcon.icon,
	"content": coalesce(richTextIcon.content.[$language][]${T},richTextIcon.content.['en'][]${T}) 
}`, Zn = t.object({
  type: t.literal("tmFlex"),
  name: t.string(),
  banner: t.array(Va),
  sections: t.array(vt),
  sidebar: t.array(jn)
}), En = u`{
  "type": _type,
  name,
  "banner": coalesce(banner[]${za}, []),
  "sections": coalesce( sections[]${_t}, []),
  "sidebar": coalesce(sidebar[]->${In}, []),
}`, On = t.object({
  type: t.literal("tmGeneral"),
  name: t.string(),
  sections: t.array(vt)
}), An = u`{
  "type": _type,
  name,
  "sections": coalesce( sections[]${_t}, []),
}`, Nn = t.object({
  plpDetail: t.array(j),
  title: t.string()
}), Rn = u`
{
  ${N("plpDetail")}[] {
    ...${T},
  },
  ${x("title")},
}
`, Ln = t.object({
  type: t.literal("atProduct"),
  label: t.string(),
  analyticsLabel: t.string(),
  slug: t.string()
}), me = u`{
  "type": _type,
  ${x("label")},
  "analyticsLabel" :coalesce(
    label['en'],       
    coalesce(label['en'], coalesce(label, ''))),
  "slug": slug,
}`, Mn = t.object({
  type: t.string(),
  title: t.string().optional(),
  textColor: t.string(),
  cta: t.object({
    label: t.string(),
    analyticsLabel: t.string(),
    url: t.string(),
    meta: t.object({
      type: t.enum(["Button", "None"])
    })
  }),
  content: t.string(),
  backgroundImage: S,
  backgroundPosition: t.enum(["left", "center", "right"]),
  productCallout: t.array(
    t.object({
      type: t.string(),
      arrowDirection: t.string(),
      horizontalPosition: t.number(),
      verticalPosition: t.number(),
      textColor: t.string(),
      label: t.string(),
      analyticsLabel: t.string(),
      url: t.string()
    })
  ).optional().nullable(),
  productOutfits: t.object({
    textColor: t.string(),
    productOutfit: t.array(Ln)
  }).optional().nullable()
}), Pn = u`{
  "type": _type,
  "title": coalesce(title, ''),
  "textColor": coalesce(textColor.value, '#ffffff'),
  "cta": {
    "label": atLink${U}.label,
    "url": atLink${U}.url,
    "analyticsLabel": coalesce(atLink.label.en, ''), 
    "meta": {
      "type": coalesce(select(atLink${U}.type == 'atLink' => 'Button', 'None')),
    }
  },
  ${x("content")},
  "backgroundImage": backgroundImage${$},
  "backgroundPosition": coalesce(backgroundPosition, 'center'),
   "productCallout": productCallout[]{
    "type": coalesce(type, 'none'),
    "arrowDirection": coalesce(arrowDirection, 'left'),
    "horizontalPosition": coalesce(horizontalPosition, 50),
    "verticalPosition": coalesce(verticalPosition, 70),
    "textColor": coalesce(textColor.value,'#ffffff'), 
    "label": productCallout[0]${me}.label,
    "analyticsLabel": productCallout[0]${me}.analyticsLabel,
    "url": productCallout[0]${me}.slug,
  },
  "productOutfits": {   
    "textColor": coalesce(productOutfits.textColor.value, textColor.value, '#ffffff'), 
    "productOutfit": coalesce(productOutfits.productOutfit[]${me}, [])
  }
  }`, Bn = t.object({
  type: t.literal("tmPlp"),
  name: t.string(),
  plpBanner: Mn.optional().nullable(),
  plpDetails: Nn.optional().nullable()
});
u`{
  "type": _type,
  "name": name, 
  plpBanner-> ${Pn},
  plpDetails-> ${Rn},

}`;
const Qn = t.object({
  type: t.literal("smAddress"),
  street: t.nullable(t.string()),
  city: t.nullable(t.string()),
  province: t.nullable(t.string()),
  country: t.nullable(t.string()),
  postalCode: t.nullable(t.string()),
  longitude: t.nullable(t.number()),
  latitude: t.nullable(t.number())
}), Dn = u`{
  "type": _type,
  street,
  city,
  province, 
  country, 
  postalCode, 
  longitude,
  latitude,
}`, Ae = t.object({
  type: t.literal("smFacility"),
  title: t.string(),
  name: t.string(),
  parentCompany: t.string(),
  owner: t.nullable(t.string()),
  vendorId: t.nullable(t.string()),
  content: t.nullable(t.array(j)),
  address: Qn,
  heroBannerImage: t.nullable(
    t.object({
      alt: t.string(),
      src: t.string(),
      quality: t.number()
    })
  ),
  tier: t.nullable(t.enum(["1", "2"])),
  relationshipSince: t.nullable(t.string()),
  numberOfEmployees: t.nullable(t.number()),
  higgRatingYear: t.nullable(t.string()),
  typeOfSupplier: t.nullable(t.array(t.enum(["Apparel", "Hard Goods", "Fabric", "Trims", "Footwear"]))),
  bluesignStatus: t.nullable(t.enum(["N/A", "Audit", "System Partner", "No", "Implementation"])),
  imageGrid: t.optional(t.array(S)),
  parentTemplate: t.nullable(
    t.object({
      pageSlug: t.nullable(t.string())
    })
  )
}), Ne = u`{
  "type": _type,
  title,
  name,
  parentCompany,
  owner,
  vendorId,
  ${N("content")}[] {
    ...${T},
  },
  "heroBannerImage": coalesce(heroBannerImage{
    "alt": coalesce(alt, ''),
    "quality": coalesce(quality, 75),
    "src": image.asset->url + '?auto=format' + '&q=' + coalesce(string(quality), '75'), 
  }, null),
  "address": address${Dn},
  "tier": coalesce(tier, "2"),
  relationshipSince,
  numberOfEmployees,
  higgRatingYear,
  typeOfSupplier,
  bluesignStatus,
  "imageGrid": coalesce(imageGrid[]${$}, []),
   // Check to see if pgPage references a tmFacility which references smFacility (this schema) and if so, return the slug
   "parentTemplate": *[_type == 'tmFacility' && references(^._id)][0]{
    "pageSlug": *[_type == 'pgPage' && references(^._id)][0].slug.current
  }
}`, Vn = t.object({
  type: t.literal("tmFacility"),
  name: t.string(),
  facility: Ae
});
u`{
  "type": _type,
  name,
  "facility": facility->${Ne},
}`;
const bt = t.object({
  marginTop: t.string().optional(),
  marginLeft: t.string().optional(),
  marginRight: t.string().optional(),
  marginBottom: t.string().optional()
});
t.object({
  paddingTop: t.string().optional(),
  paddingLeft: t.string().optional(),
  paddingRight: t.string().optional(),
  paddingBottom: t.string().optional()
});
const xt = t.object({
  alignItems: t.string().optional(),
  flexDirection: t.string().optional(),
  justifyContent: t.string().optional(),
  gap: t.string().optional()
}), kt = t.object({
  maxWidth: t.string().optional(),
  maxHeight: t.string().optional(),
  width: t.string().optional(),
  height: t.string().optional()
}), zn = t.object({
  breakpoint: t.string(),
  type: t.string(),
  _key: t.string()
}).merge(xt), Un = u`{
    breakpoint,
    ...stylesFlex,
    "_key": _key,
    "type": _type
  }`, qn = t.object({
  _key: t.string(),
  type: t.string(),
  breakpoint: t.string()
}).merge(xt).merge(kt).merge(bt), Wn = u`{
  "_key": _key,
  "type": _type,
  breakpoint,
  ...stylesFlex,
  ...stylesGap,
  ...stylesJustify,
  ...stylesSize,
  ...stylesMargin
}`, Fn = t.object({
  fontFamily: t.string().optional(),
  fontSize: t.string().optional(),
  fontWeight: t.string().optional(),
  letterSpacing: t.string().optional(),
  lineHeight: t.string().optional(),
  textAlign: t.any().optional(),
  color: t.string().optional(),
  textTransform: t.string().optional(),
  textShadow: t.string().optional()
}), wt = t.object({
  breakpoint: t.string()
}).merge(Fn).merge(bt).merge(kt), Tt = u`{
		...stylesFont,
		...stylesMargin,
		...stylesSize,
		stylesFont.color != null => {"color" : stylesFont.color.value},
		breakpoint
		}`, Gn = t.object({
  type: t.literal("headline"),
  headline: t.string(),
  responsiveStyles: t.array(wt)
}), Hn = u`{
    "type": _type,
    ${x("headline")},
    "responsiveStyles": coalesce(responsiveStyles[]${Tt},[]),
    }`, Jn = t.object({
  type: t.literal("textArea"),
  textarea: t.string(),
  responsiveStyles: t.array(wt)
}), Yn = u`{
    "type": _type,
    ${x("textarea")},
    "responsiveStyles": coalesce(responsiveStyles[]${Tt},    []),
   }`, Xn = t.object({
  buttonUrl: t.string(),
  label: t.string(),
  promotionId: t.string().optional(),
  youtubeId: t.string().optional()
}), Kn = t.object({
  breakpoint: t.string(),
  flexDirection: t.string().optional(),
  width: t.string().optional(),
  fontSize: t.string().optional(),
  backgroundColor: t.string().optional(),
  color: t.string().optional(),
  textTransform: t.string().optional(),
  alignItems: t.string().optional(),
  justifyContent: t.string().optional()
}), er = t.object({
  type: t.literal("buttonGroup"),
  buttons: t.array(Xn),
  adornment: t.string().optional(),
  responsiveStyles: t.array(Kn)
}), tr = u`{
    ...,
    "type": _type,
    "buttons": buttons[]{
        ...,
        "label": coalesce(
        label[$language],       
        coalesce(label['en'],
        coalesce(label, ''))
        ),
        "buttonUrl": coalesce(
        buttonUrl[$language],
        coalesce(buttonUrl['en'],
        coalesce(buttonUrl, ''))
        ),
    },
    "responsiveStyles": coalesce(
    translatedResponsiveStyles[$language].responsiveStyles,       
    translatedResponsiveStyles['en'].responsiveStyles,
    []
    ),
  }`, St = t.union([S, Gn, Jn, er]), ar = t.object({
  type: t.literal("contentBlockFlex"),
  backgroundImage: S,
  containerStyles: t.array(zn),
  elementsContainerStyles: t.array(qn),
  elements: t.array(St)
}), nr = t.object({
  type: t.literal("contentBlockGrid"),
  backgroundImage: S,
  elements: t.array(St)
}), rr = t.object({
  sectionType: t.enum(["hero", "secondary", "tertiary"]),
  type: t.literal("section"),
  key: t.string(),
  contentBlocks: t.array(t.union([
    ar,
    nr
  ]))
}), sr = u`
{
    sectionType,
    "type": _type,
    "key": _key,
    contentBlocks []{
        "type": _type,
        "backgroundImage": backgroundImage${$},
        "containerStyles": coalesce(containerStyles[]${Un}, []),
        "elementsContainerStyles": coalesce(elementsContainerStyles[]${Wn}, []),
        "elements": elements[]{
            _type == 'textArea' => ${Yn},
            _type == 'headline' => ${Hn},
            _type == 'atImage' => ${$},
            _type == 'buttonGroup' => ${tr},
        }
    }
}`, ir = t.object({
  type: t.literal("tmHome"),
  name: t.string(),
  sections: t.array(rr)
}), or = u`{
  "type": _type,
  name,
  "sections": coalesce(sections[]${sr}, []),
}`, lr = t.object({
  type: t.literal("tmFacilityHub"),
  name: t.string(),
  blurb: t.array(j),
  facilityMap: t.array(Ae),
  facilityTable: t.array(Ae)
});
u`{
  "type": _type,
  name,
  ${N("blurb")}[] {
    ...${T},
  },
  "facilityMap": facilityMap[]->${Ne},
  "facilityTable": facilityTable[]->${Ne},
}`;
const cr = t.object({
  type: t.literal("socialMediaLink"),
  socialMediaPlatform: t.string(),
  url: t.string()
}), ur = u`{
  ...,
  "type": _type,
}`, dr = t.object({
  type: t.literal("athlete"),
  homeTown: t.string(),
  sports: t.array(t.string()),
  socialMediaLinks: t.array(cr),
  isDeceased: t.boolean(),
  bio: t.array(j),
  image: S,
  name: t.string()
}), pr = u`{
    ...,
    "type": _type,
    "socialMediaLinks": coalesce(socialMediaLinks[]${ur}, []),
    "sports": coalesce(sports, []),
    "homeTown": coalesce(homeTown, ""),
    ${N("bio")}[] {
      ...${T}
    },
    "image": image${$},
}`, $t = t.object({
  type: t.literal("tmAthlete"),
  name: t.string(),
  athlete: dr
}), mr = u`{
    "type": _type,
    name,
    "athlete": athlete -> ${pr},
}`, hr = t.object({
  id: t.string(),
  sports: t.array(t.string()),
  name: t.string(),
  image: S,
  isDeceased: t.boolean()
}), gr = t.object({
  type: t.literal("tmAthleteHub"),
  heroBanner: ut,
  blurb: t.array(j),
  athletes: t.array(hr)
}), fr = u`{
        ...,
        "id": _id,
        "sports": coalesce(sports, []),
        "image": image${$},
}`;
u`{
    "type": _type, 
    "heroBanner": heroBanner${dt},
    ${N("blurb")}[] {
    ...${T},
    },
    "athletes": athletes[] -> ${fr}
}`;
const yr = t.union([
  Zn,
  On,
  Bn,
  ir
]), vr = t.union([
  Vn,
  lr,
  $t,
  gr
]), _r = t.union([yr, vr]), br = t.object({
  slug: t.string(),
  market: t.string(),
  region: t.string(),
  title: t.string(),
  description: t.string(),
  breadcrumbs: t.optional(Pa),
  template: _r,
  nofollow: t.boolean().optional(),
  noindex: t.boolean().optional()
}), xr = u`
{
  "slug": slug.current,
  market,
  "region": coalesce(multiRegions, region),
  "nofollow": coalesce(seo.nofollow, false),
  "noindex": coalesce(seo.noindex, false),
  ${x("title")},
  ${x("description")},
  "template": template->{
    _type,
    ...select(
      _type == 'tmFlex' => ${En},
      _type == 'tmGeneral' => ${An},
      _type == 'tmHome' => ${or},
    )
  },
  breadcrumbs != null => {
    "breadcrumbs": breadcrumbs${Ba}
  }
}`, kr = u`
[
  $country in coalesce(multiRegions, [region]) ||
  select($country in ['ca', 'us'] => 'nam', 'emea') in coalesce(multiRegions, [region]) ||
  'global' in coalesce(multiRegions, [region])
 ]{
  ...,
  "priority": select(
    $country in coalesce(multiRegions, [region]) => 3,
    select($country in ['ca', 'us'] => 'nam', 'emea') in coalesce(multiRegions, [region]) => 2,
    'global' in coalesce(multiRegions, [region]) => 1
  )
} | order(priority desc)[0]
`, Ct = u`*[
  _type == 'pgPage'
  && slug.current == $slug
  && $market match market
] ${kr}`, wr = (n) => n, Tr = t.object({
  slug: t.string(),
  market: t.string(),
  region: t.string(),
  title: t.string(),
  description: t.string(),
  template: $t
}), Sr = u`
{
  "slug": slug.current,
  market,
  region,
  ${x("title")},
  ${x("description")},
  "template": template->${mr},
}`, Mr = async (n, e) => {
  const a = Re(e), r = u`
      ${Ct}
      ${Sr}
    `;
  try {
    const s = await n.fetch(r, a);
    return s ? Tr.parse(s) : null;
  } catch (s) {
    throw s instanceof Error ? new Error(s.message) : new Error("An unknown error occurred");
  }
}, $r = t.array(t.object({
  slug: t.string(),
  name: t.string(),
  imageSource: t.string(),
  sports: t.array(t.string()),
  isDeceased: t.boolean(),
  id: t.string()
})), Cr = u`*[_type=="pgPage" && references(*[_type=="tmAthlete"]._id)]{
    "slug":slug.current,
    ...template -> athlete -> {
       ..., 
       "id": _id,
       "imageSource":  image.image.asset -> url + '?auto=format' + '&q=70&h=260&w=260',
       "sports" : coalesce(sports, []),

    }
  }`, Pr = async (n) => {
  try {
    const e = await n.fetch(Cr);
    return e ? $r.parse(e) : null;
  } catch (e) {
    throw console.error(e), e instanceof Error ? new Error(e.message) : new Error("An unknown error occurred");
  }
}, Br = async (n, e) => {
  const a = Re(e), r = u`
    ${Ct}
    ${xr}
  `;
  try {
    const s = await n.fetch(r, wr(a));
    if (!s)
      throw new Error("No data returned from Sanity");
    return br.parse(s);
  } catch (s) {
    throw s instanceof Error ? new Error(s.message) : new Error("An unknown error occurred");
  }
}, jr = t.object({
  name: t.string(),
  portableText: t.array(et)
}), Ir = u`{
  name,
  "portableText": coalesce(
    translations[$language],
    translations.en
  )
}`, Zr = t.object({
  name: t.string(),
  header: t.array(
    t.object({
      callToAction: t.array(
        t.object({
          link: t.string(),
          linkText: t.string()
        })
      ),
      header: t.string()
    })
  )
}), Er = u`
{
  name,
  "header": header[] {
    callToAction[] {
      ${x("link")},
      ${x("linkText")},
    },
     ${x("header")},
  }
}`, Qr = t.object({
  promoMessage: jr.optional().nullable(),
  staticSearchLinks: Zr.optional().nullable()
}), Or = u`{
  "promoMessage": coalesce(
    promoMessage[$country],
    select($country in ['ca','us'] => promoMessage.nam, promoMessage.emea),
    promoMessage.global
  ) -> ${Ir}
}`, Ar = u`{
  "staticSearchLinks": coalesce(
    staticSearchLinks[$country],
    select($country in ['ca','us'] => staticSearchLinks.nam, staticSearchLinks.emea),
    staticSearchLinks.global
  ) -> ${Er}
}`, jt = u`
  {
    "settings": *[
      (_type == 'smMarketSettings')&&
      _id == $market
    ][0]
  }.settings
`, Dr = u`
  ${jt}
  ${Or}
`, Vr = u`
  ${jt}
  ${Ar}
`, zr = (n) => n;
export {
  Re as adaptPageParams,
  Lr as fetchAlertBanner,
  Mr as fetchAthlete,
  Pr as fetchAthleteHubAthletes,
  Br as fetchPage,
  Ce as fullWidthImageQuery,
  $e as fullWidthImageSchema,
  $ as imageQuery,
  Ca as imageRecordSchema,
  S as imageSchema,
  U as linkQuery,
  Se as linkSchema,
  kr as pageRegionOrderedFilter,
  T as portableTextQuery,
  j as portableTextSchema,
  ee as richTextContainerQuery,
  K as richTextContainerSchema,
  nt as richTextIconQuery,
  at as richTextIconSchema,
  Dr as siteSettingsDocumentQuery,
  zr as siteSettingsQueryParams,
  Qr as siteSettingsSchema,
  Vr as siteSettingsStaticSearchLinksDocumentQuery,
  Rr as translateArrayQuery,
  N as translateObjectQuery,
  Nr as translateStringArrayQuery,
  x as translateStringQuery
};
